"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("@seedlang/constants");
var _layouts = require("@seedlang/layouts");
var _models = require("@seedlang/models");
var _stores = require("@seedlang/stores");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _mobx = require("mobx");
var _serializr = require("serializr");
var _exercise_ui = _interopRequireDefault(require("./exercise_ui"));
var _overlay_ui = _interopRequireDefault(require("./overlay_ui"));
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var DeckUI = (_class = /*#__PURE__*/function (_RootState) {
  function DeckUI() {
    var _this;
    _classCallCheck(this, DeckUI);
    _this = _callSuper(this, DeckUI);
    _initializerDefineProperty(_this, "cardSeenCount", _descriptor, _this);
    _initializerDefineProperty(_this, "wordClickCount", _descriptor2, _this);
    _initializerDefineProperty(_this, "seenConceptDescription", _descriptor3, _this);
    _initializerDefineProperty(_this, "selectedConceptDescriptionOpen", _descriptor4, _this);
    _initializerDefineProperty(_this, "cardNotice", _descriptor5, _this);
    _initializerDefineProperty(_this, "showCloseModal", _descriptor6, _this);
    _initializerDefineProperty(_this, "animationQueue", _descriptor7, _this);
    _initializerDefineProperty(_this, "deckNavigationCompleted", _descriptor8, _this);
    _initializerDefineProperty(_this, "deckScreenFocused", _descriptor9, _this);
    _initializerDefineProperty(_this, "lastFeedEntryId", _descriptor0, _this);
    _initializerDefineProperty(_this, "dataSaverModalSeen", _descriptor1, _this);
    _initializerDefineProperty(_this, "enrichedTranslations", _descriptor10, _this);
    _initializerDefineProperty(_this, "overlayExpanded", _descriptor11, _this);
    _initializerDefineProperty(_this, "sound", _descriptor12, _this);
    _initializerDefineProperty(_this, "textRevealed", _descriptor13, _this);
    _initializerDefineProperty(_this, "arrowBoxIsHidden", _descriptor14, _this);
    _initializerDefineProperty(_this, "cardIsAnimating", _descriptor15, _this);
    _initializerDefineProperty(_this, "nativeCardTransition", _descriptor16, _this);
    _initializerDefineProperty(_this, "firstCardHasAdvanced", _descriptor17, _this);
    // Retain legacy fields for debug-report compatibility; native positioning
    // now uses ordinary layout plus a temporary nativeCardTransition.
    _initializerDefineProperty(_this, "suppressCardSwipeSpring", _descriptor18, _this);
    _initializerDefineProperty(_this, "cardAnimationRecoveryRevision", _descriptor19, _this);
    _initializerDefineProperty(_this, "cardAnimationNativeMountId", _descriptor20, _this);
    _initializerDefineProperty(_this, "userInputStores", _descriptor21, _this);
    _initializerDefineProperty(_this, "shortcutsAssigned", _descriptor22, _this);
    _initializerDefineProperty(_this, "animationCards", _descriptor23, _this);
    _initializerDefineProperty(_this, "deviceDeniedAccess", _descriptor24, _this);
    _initializerDefineProperty(_this, "showSlowDeckLoadingWarning", _descriptor25, _this);
    _initializerDefineProperty(_this, "localDeck", _descriptor26, _this);
    _initializerDefineProperty(_this, "localUserDeck", _descriptor27, _this);
    _initializerDefineProperty(_this, "hideCardIcons", _descriptor28, _this);
    _initializerDefineProperty(_this, "warning", _descriptor29, _this);
    _initializerDefineProperty(_this, "showCorrectAnswer", _descriptor30, _this);
    _initializerDefineProperty(_this, "reviewCards", _descriptor31, _this);
    _initializerDefineProperty(_this, "reviewSessionReviewedBaseline", _descriptor32, _this);
    _this.deckNavigation = null;
    _this.nativeCreateWordStore = null;
    _this.deckLoadRequestId = 0;
    _this.cardAnimationStartTimeout = null;
    _this.cardAnimationRemoveTimeout = null;
    _this.cardAnimationSafetyTimeout = null;
    _this.cardAnimationForegroundResyncTimeout = null;
    _this.lastRevealAt = 0;
    _this.getReviewCards = function () {
      if (!_this.reviewDeck) {
        _this.cardStore.getIndex({
          queryStrings: {
            reviews_for_deck_id: _this.deck.id
          }
        }, _this.afterGetReviewCards);
      }
    };
    _this.afterGetReviewCards = function (resp) {
      if (!(0, _lodash.isArray)(resp)) {
        return;
      }
      _this.reviewCards = resp.map(function (item) {
        var _item$word, _item$sentence, _item$word2, _item$sentence2, _item$cardType;
        return {
          id: item.id,
          translationId: ((_item$word = item.word) === null || _item$word === void 0 ? void 0 : _item$word.id) || ((_item$sentence = item.sentence) === null || _item$sentence === void 0 ? void 0 : _item$sentence.id),
          wordId: (_item$word2 = item.word) === null || _item$word2 === void 0 ? void 0 : _item$word2.id,
          sentenceId: (_item$sentence2 = item.sentence) === null || _item$sentence2 === void 0 ? void 0 : _item$sentence2.id,
          cardTypeId: (_item$cardType = item.cardType) === null || _item$cardType === void 0 ? void 0 : _item$cardType.id,
          deckId: item.deckId,
          pronoun: item.pronoun,
          tenseConceptId: item.tenseConceptId,
          wordAssociationIds: item.wordAssociationIds,
          sourceCardId: item.sourceCardId,
          synonymAssociationId: item.synonymAssociationId,
          exerciseId: item.exerciseId
        };
      });
    };
    _this.reviewCard = function (card, deckId) {
      var _this$reviewCards;
      var reviewCards = (_this$reviewCards = _this.reviewCards) === null || _this$reviewCards === void 0 || (_this$reviewCards = _this$reviewCards.filter(function (item) {
        var _card$translation;
        return ((0, _utils.isPresent)((_card$translation = card.translation) === null || _card$translation === void 0 ? void 0 : _card$translation.id) && (item.wordId === card.translation.id || item.sentenceId === card.translation.id || item.translationId === card.translation.id) || (0, _utils.isPresent)(card.exerciseId) && item.sourceCardId === card.id) && item.cardTypeId === card.cardTypeId && item.pronoun === card.pronoun && item.tenseConceptId === card.tenseConceptId;
      })) === null || _this$reviewCards === void 0 ? void 0 : _this$reviewCards.filter(function (item) {
        return _this.reviewCardMatchesSynonymAssociation(card, item);
      });
      if ((0, _utils.isPresent)(deckId)) {
        return reviewCards === null || reviewCards === void 0 ? void 0 : reviewCards.find(function (item) {
          return item.deckId === deckId;
        });
      }
      if ((0, _utils.isPresent)(reviewCards)) {
        return reviewCards[0];
      }
    };
    _this.onCreateEventBlocked = function (eventType) {
      if (_this.user.blockUserTracking) {
        if (_this.logger) {
          _this.logger.log('Event creation skipped - tracking blocked', {
            eventType: eventType
          });
        }
      }
    };
    _this.onCreateEventStart = function (eventType, safeParams) {
      // Keep recorder payloads out of logs while preserving full event data for tracking.
      if (_this.logger) {
        var loggedParams = safeParams.audio_recorder_logs ? _objectSpread(_objectSpread({}, safeParams), {}, {
          audio_recorder_logs: '[omitted for log report]'
        }) : safeParams;
        _this.logger.log('Creating event', {
          eventType: eventType,
          params: loggedParams
        });
      }
    };
    _this.nativeCreateEventArgs = function () {
      return {
        logger: _this.logger
      };
    };
    _this.webPosthogTrackingAllowed = function () {
      return (0, _utils.shouldTrackWebPosthog)({
        siteIsSeedlang: _this.siteIsSeedlang,
        user: _this.user,
        allowCookies: (0, _utils.getCookieValue)('allow-cookies') === true
      });
    };
    _this.posthogEventParams = function (eventType) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (0, _utils.buildWebPosthogEventProperties)({
        eventType: eventType,
        params: params,
        user: _this.user,
        site: _this.site
      });
    };
    _this.addCardToReviewCards = function (card, deckId) {
      var _card$translation2, _card$cardType;
      if (_this.reviewCard(card, deckId || card.deckId)) {
        return;
      }
      _this.reviewCards.push({
        id: '999',
        // temp ID before returned from server
        translationId: (_card$translation2 = card.translation) === null || _card$translation2 === void 0 ? void 0 : _card$translation2.id,
        cardTypeId: (_card$cardType = card.cardType) === null || _card$cardType === void 0 ? void 0 : _card$cardType.id,
        deckId: deckId || _this.deck.id,
        pronoun: card.pronoun,
        tenseConceptId: card.tenseConceptId,
        wordAssociationIds: card.wordAssociationIds,
        sourceCardId: card.id,
        synonymAssociationId: card.synonymAssociationId,
        exerciseId: card.exerciseId
      });
    };
    _this.removeCardFromReviewCards = function (card, deckId) {
      var _card$word, _card$sentence;
      if (!_this.reviewCard(card, deckId)) {
        return;
      }
      var translationId = ((_card$word = card.word) === null || _card$word === void 0 ? void 0 : _card$word.id) || ((_card$sentence = card.sentence) === null || _card$sentence === void 0 ? void 0 : _card$sentence.id);
      (0, _lodash.remove)(_this.reviewCards, function (item) {
        return ((0, _utils.isPresent)(translationId) && item.translationId === translationId || (0, _utils.isPresent)(card.exerciseId) && item.sourceCardId === card.id) && item.deckId === deckId && item.cardTypeId === card.cardType.id && item.pronoun === card.pronoun && item.tenseConceptId === card.tenseConceptId && _this.reviewCardMatchesSynonymAssociation(card, item);
      });
    };
    _this.reviewCardMatchesSynonymAssociation = function (card, reviewCard) {
      var _card$cardType2;
      if (((_card$cardType2 = card.cardType) === null || _card$cardType2 === void 0 ? void 0 : _card$cardType2.slug) !== 'synonym' && card.cardTypeSlug !== 'synonym') {
        return true;
      }
      return card.synonymAssociationId === reviewCard.synonymAssociationId;
    };
    _this.normalizeString = function (string) {
      var forceLowerCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if ((0, _utils.isBlank)(string)) {
        return;
      }
      var str = (0, _utils.normalizeCharacters)(string);
      if (_this.deck.languageId === 'DE') {
        str = str.replace(/é/g, 'e').replace(/É/g, 'E');
      }
      if (_this.user.enforceCasing && !forceLowerCase) {
        return str;
      }
      return str.toLowerCase();
    };
    _this.getEvaluateTextInputMatch = function (word, cardState) {
      var lowerCase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var localNormalizedTextEntry = word ? _this.normalizeString(cardState.textEntry, lowerCase) : null;
      var matchTargetTextWithDefiniteArticle = word && localNormalizedTextEntry && localNormalizedTextEntry === _this.normalizeString(word.targetTextWithDefiniteArticle, lowerCase);
      var matchTargetTextWithDefiniteArticleNoParenthesis = word && localNormalizedTextEntry && localNormalizedTextEntry === _this.normalizeString(word.targetTextWithDefiniteArticleNoParenthesis, lowerCase);
      var matchTargetTextWithoutDefiniteArticle = word && localNormalizedTextEntry && word.useParenthesesOnGender && localNormalizedTextEntry === _this.normalizeString(word.targetText, lowerCase);
      var matchHundertOrTausendPlusEin = word && word.isNumber && localNormalizedTextEntry && (word.targetText.startsWith('hundert') || word.targetText.startsWith('tausend')) && localNormalizedTextEntry.replace(/^ein/, '') === _this.normalizeString(word.targetText, lowerCase);
      var matchEinhundertOrEintausendWithoutEin = word && word.isNumber && localNormalizedTextEntry && (word.targetText.startsWith('einhundert') || word.targetText.startsWith('eintausend')) && localNormalizedTextEntry === _this.normalizeString(word.targetText, lowerCase).replace(/^ein/, '');
      return matchTargetTextWithDefiniteArticle || matchTargetTextWithDefiniteArticleNoParenthesis || matchTargetTextWithoutDefiniteArticle || matchHundertOrTausendPlusEin || matchEinhundertOrEintausendWithoutEin;
    };
    _this.textEntryMatchesSynonym = function (word, cardState) {
      if ((0, _utils.isBlank)(word.synonymAssociations) || (0, _utils.isBlank)(cardState.textEntry)) {
        return;
      }
      return (0, _lodash.some)(word.synonymAssociations.map(function (item) {
        return _this.getEvaluateTextInputMatch(item.synonym, cardState);
      }));
    };
    _this.resetReviewsDeckFilter = function () {
      _this.deckStore.update({
        ids: {
          deckId: _this.deck.id
        },
        data: {
          reviewsFilterDue: 'past-due'
        }
      }, _this.afterResetReviewsDeckFilter);
    };
    _this.afterResetReviewsDeckFilter = function () {
      _this.resetDeck();
      _this.hideCardNotice();
    };
    _this.afterSelectCard = function (deckLoadRequestId, userDeckId) {
      if (deckLoadRequestId !== _this.deckLoadRequestId) {
        return;
      }
      _this.userDeckStore.getShow({
        ids: {
          userDeckId: userDeckId
        }
      }, _this.afterGetSelectedUserDeck.bind(_this, deckLoadRequestId, userDeckId), {
        failureCallback: _this.completeUserDeckLoadIfCurrent.bind(_this, deckLoadRequestId),
        onRequestError: _this.completeUserDeckLoadIfCurrent.bind(_this, deckLoadRequestId)
      });
    };
    _this.afterGetSelectedUserDeck = function (deckLoadRequestId, userDeckId, resp) {
      if (deckLoadRequestId !== _this.deckLoadRequestId || resp.id !== userDeckId) {
        return;
      }
      _this.userDeckStore.setShowData(resp);
      _this.completeUserDeckLoad();
    };
    _this.completeUserDeckLoadIfCurrent = function (deckLoadRequestId) {
      if (deckLoadRequestId === _this.deckLoadRequestId) {
        _this.completeUserDeckLoad();
      }
    };
    _this.completeUserDeckLoad = function () {
      if (_this.reviewDeck) {
        _this.reviewSessionReviewedBaseline = _this.deck.reviewedToday;
      } else {
        _this.reviewSessionReviewedBaseline = null;
      }
      _this.initializeCardAnimation();
    };
    _this.onToggleRecordAudio = function () {
      var _this$userInputStores, _this$userInputStores2;
      if (!_this.currentCard || !_this.canRecordMedia) {
        return;
      }
      if ((_this$userInputStores = _this.userInputStores[_this.currentCard.id]) !== null && _this$userInputStores !== void 0 && _this$userInputStores.isRecording) {
        _this.reveal(_this.currentCard, _this.currentCardState);
      }
      (_this$userInputStores2 = _this.userInputStores[_this.currentCard.id]) === null || _this$userInputStores2 === void 0 || _this$userInputStores2.onToggleRecordAudio();
    };
    _this.setWord = function (word) {
      _this.wordStore.setShowData(word);
      if (word.hasDictionaryConcept || word.hasRelatedWords) {
        _this.wordStore.getShow({
          ids: {
            wordId: word.id
          }
        });
      }
    };
    _this.setDeckNavigation = function () {
      var navigation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      _this.deckNavigation = navigation;
    };
    _this.setNativeCreateWordStore = function () {
      var createWordStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      _this.nativeCreateWordStore = createWordStore;
    };
    _this.soundEffectStore = _stores.SoundEffectStore;
    _this.xpState = _models.XpState;
    _this.deckStore = _stores.DeckStore;
    _this.cardStore = _stores.CardStore;
    _this.eventStore = _stores.EventStore;
    _this.logger = null;
    _this.authUserStore = _stores.AuthUserStore;
    _this.levelStore = _stores.LevelStore;
    _this.conceptStore = _stores.ConceptStore;
    _this.userTranslationStore = _stores.UserTranslationStore;
    _this.userConceptStore = _stores.UserConceptStore;
    _this.pageStore = _stores.PageStore;
    _this.layout = new _layouts.DeckLayout(_this);
    _this.feedEntryStore = _stores.FeedEntryStore;
    _this.wordStore = _stores.WordStore;
    _this.wordSentenceStore = _stores.WordSentenceStore;
    _this.conceptSentenceStore = _stores.ConceptSentenceStore;
    _this.routeStore = _stores.RouteStore;
    _this.deckFeedEntryStore = _stores.DeckFeedEntryStore;
    _this.wordTypeStore = _stores.WordTypeStore;
    _this.userDeckStore = _stores.UserDeckStore;
    _this.userCardStore = _stores.UserCardStore;
    _this.translationSourceStore = _stores.TranslationSourceStore;
    _this.sentenceStore = _stores.SentenceStore;
    _this.conceptWordStore = _stores.ConceptWordStore;
    _this.reviewStore = _stores.ReviewStore;
    _this.targetLanguageStore = _stores.TargetLanguageStore;
    _this.loadDeckStartTime;
    _this.onNewDeck();
    (0, _mobx.autorun)(function () {
      if (_this.mediaBlocked) {
        _this.pauseMedia();
      }
    });
    return _this;
  }
  _inherits(DeckUI, _RootState);
  return _createClass(DeckUI, [{
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "treeNodeId",
    get: function get() {
      if (this.deck && this.deck.treeNodeIds) {
        return this.deck.treeNodeIds.split(',')[0];
      }
    }
  }, {
    key: "deck",
    get: function get() {
      return this.deckStore.showData;
    }
  }, {
    key: "deckTypeForAnalytics",
    value: function deckTypeForAnalytics() {
      var _deck$deckRulebook;
      var deck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.deck;
      return (deck === null || deck === void 0 ? void 0 : deck.deckType) || (deck === null || deck === void 0 || (_deck$deckRulebook = deck.deckRulebook) === null || _deck$deckRulebook === void 0 ? void 0 : _deck$deckRulebook.slug) || null;
    }
  }, {
    key: "deckState",
    get: function get() {
      return this.deck.deckState;
    }
  }, {
    key: "userDeck",
    get: function get() {
      return this.userDeckStore.showData;
    }
  }, {
    key: "currentCard",
    get: function get() {
      var _this$deck$cards,
        _this2 = this;
      return this.deckLoaded ? (_this$deck$cards = this.deck.cards) === null || _this$deck$cards === void 0 ? void 0 : _this$deck$cards.find(function (item) {
        return item.id === _this2.userDeck.currentCardId;
      }) : {};
    }
  }, {
    key: "currentUserCard",
    get: function get() {
      var _this3 = this;
      return (0, _utils.isPresent)(this.userDeck) ? this.userDeck.userCards.find(function (item) {
        return item.cardId === _this3.userDeck.currentCardId;
      }) : {};
    }
  }, {
    key: "currentCardState",
    get: function get() {
      return (0, _utils.isPresent)(this.currentCard) ? this.currentCard.cardState : {};
    }
  }, {
    key: "siteIsSeedlang",
    get: function get() {
      if (this.layout.isNative) {
        return true;
      } else if ((0, _utils.isPresent)(this.site)) {
        return this.site.isSeedlang;
      }
      return this.siteIsSeedlangFromUrl;
    }
  }, {
    key: "siteIsMemrev",
    get: function get() {
      return !this.siteIsSeedlang;
    }
  }, {
    key: "site",
    get: function get() {
      var _this$user;
      return (_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.site;
    }
  }, {
    key: "targetLanguageId",
    get: function get() {
      if (this.siteIsMemrev && (0, _utils.isPresent)(this.site)) {
        return this.site.languageId;
      } else if (this.updatedDeviceLanguageId && this.updatedDeviceLanguageId !== 'all') {
        return this.updatedDeviceLanguageId;
      } else if (this.layout.deviceLanguageId && this.layout.deviceLanguageId !== 'all') {
        return this.layout.deviceLanguageId;
      } else if (this.userIsLoaded) {
        return this.user.targetLanguageId;
      }
      return 'DE';
    }
  }, {
    key: "targetLanguage",
    get: function get() {
      var _this4 = this;
      if (!this.userIsLoaded) {
        return {};
      }
      var tl = this.user.targetLanguages.find(function (item) {
        return item.languageId === _this4.targetLanguageId;
      });
      return tl || this.user.defaultTargetLanguage;
    }
  }, {
    key: "routeToOnClose",
    get: function get() {
      if (this.deck.triviaDeck && (!this.treeNodeId || _constants.Constants.TRIVIA_TREE_NODES.includes(this.treeNodeId))) {
        return 'trivia.home';
      }
      if (this.storyDeck || this.treeNodeId && !_constants.Constants.TRIVIA_TREE_NODES.includes(this.treeNodeId)) {
        return 'stories.home';
      }
      if (this.vocabDeck || this.deck.pluralDeck || this.deck.genderDeck || this.deck.conjugationDeck || this.deck.numberDeck || this.deck.caseDeck || this.deck.synonymDeck) {
        return 'vocab.home';
      }
      return 'review.home';
    }
  }, {
    key: "userInputStore",
    get: function get() {
      return this.currentCard && this.userInputStores[this.currentCard.id] ? this.userInputStores[this.currentCard.id] : {};
    }
  }, {
    key: "clearAudioStreams",
    value: function clearAudioStreams() {
      var cleanupPromises = [];
      (0, _lodash.each)(this.userInputStores, function (store) {
        if (store.cleanupOffscreen) {
          cleanupPromises.push(store.cleanupOffscreen());
        } else {
          store.clearAudioStream();
        }
      });
      return Promise.all(cleanupPromises);
    }
  }, {
    key: "disposeAllUserInputStores",
    value: function disposeAllUserInputStores() {
      if (!this.userInputStores) {
        return Promise.resolve();
      }
      var disposePromises = [];
      (0, _lodash.each)(this.userInputStores, function (store) {
        if (!store) {
          return;
        }
        var disposePromise = Promise.resolve();
        if (store.isNative && store.onReset) {
          disposePromise = Promise.resolve(store.onReset());
        }
        if (store.dispose) {
          disposePromise = disposePromise.then(function () {
            return store.dispose();
          });
        } else if (store.onReset) {
          disposePromise = disposePromise.then(function () {
            return store.onReset();
          });
        }
        disposePromises.push(disposePromise);
      });
      this.userInputStores = {};
      return Promise.all(disposePromises);
    }
  }, {
    key: "disposeDeckResources",
    value: function disposeDeckResources() {
      this.nativeCardTransition = null;
      this.clearCardAnimationTimeouts();
      var disposePromise = this.disposeAllUserInputStores();
      this.userDeckStore.clearShowData();
      this.conceptWordStore.clearIndexData();
      this.enrichedTranslations = {};
      this.animationCards = [];
      this.animationQueue = [];
      return disposePromise;
    }
  }, {
    key: "resetAllUserInputStores",
    value: function resetAllUserInputStores() {
      if (!this.userInputStores) {
        return;
      }
      (0, _lodash.each)(this.userInputStores, function (store) {
        if (!store) {
          return;
        }
        if (store.onReset) {
          store.onReset();
        }
      });
    }
  }, {
    key: "commentDebugInfo",
    get: function get() {
      return {
        userInfo: this.debugInfo['userInfo'],
        deckInfo: this.debugInfo['deckInfo'],
        card: this.debugInfo['cards'].find(function (item) {
          return item.active;
        }),
        animationCards: this.debugInfo['animationCards']
      };
    }
  }, {
    key: "optionText",
    value: function optionText(option) {
      return (option === null || option === void 0 ? void 0 : option.text) || (option === null || option === void 0 ? void 0 : option.value) || (option === null || option === void 0 ? void 0 : option.targetText) || (option === null || option === void 0 ? void 0 : option.sourceText) || (option === null || option === void 0 ? void 0 : option.prompt) || (option === null || option === void 0 ? void 0 : option.id);
    }
  }, {
    key: "pluralMultipleChoiceOptions",
    value: function pluralMultipleChoiceOptions(card) {
      var word = card.word || (card.translationType === 'Word' ? card.translation : null);
      if ((0, _utils.isPresent)(word === null || word === void 0 ? void 0 : word.randomPluralOptions)) {
        return word.randomPluralOptions;
      }
      if ((0, _utils.isPresent)(word === null || word === void 0 ? void 0 : word.pluralOptions)) {
        return word.pluralOptions.split(',').map(function (item) {
          return {
            id: item,
            value: "".concat(word.pluralArticle || 'die', " ").concat(item)
          };
        });
      }
      return null;
    }
  }, {
    key: "submittedValueText",
    value: function submittedValueText(exerciseEntry, submittedValue) {
      var _this5 = this;
      var submittedValues = submittedValue.toString().split(',');
      var options = [].concat(_toConsumableArray(exerciseEntry.mediaOptions || []), _toConsumableArray(exerciseEntry.multipleChoiceOptions || []));
      var optionTexts = submittedValues.map(function (value) {
        var option = options.find(function (item) {
          var _item$id;
          return ((_item$id = item.id) === null || _item$id === void 0 ? void 0 : _item$id.toString()) === value;
        });
        return _this5.optionText(option) || value;
      });
      return optionTexts.join(', ');
    }
  }, {
    key: "exerciseEntryUserInput",
    value: function exerciseEntryUserInput(exerciseEntry) {
      var _exerciseEntry$state$, _exerciseEntry$senten;
      var ary = [];
      if (!(exerciseEntry !== null && exerciseEntry !== void 0 && exerciseEntry.state) || exerciseEntry.state.blankValueFilledIn) {
        return null;
      }
      if ((0, _utils.isPresent)(exerciseEntry.state.submittedValue)) {
        ary.push(this.submittedValueText(exerciseEntry, exerciseEntry.state.submittedValue));
      }
      if ((0, _utils.isPresent)((_exerciseEntry$state$ = exerciseEntry.state.assignedExerciseEntry) === null || _exerciseEntry$state$ === void 0 ? void 0 : _exerciseEntry$state$.id)) {
        ary.push(exerciseEntry.state.assignedExerciseEntry.prompt);
      }
      if ((0, _utils.isPresent)((_exerciseEntry$senten = exerciseEntry.sentence) === null || _exerciseEntry$senten === void 0 ? void 0 : _exerciseEntry$senten.wordAssociations)) {
        exerciseEntry.sentence.wordAssociations.forEach(function (wordAssociation) {
          if (!wordAssociation.state.blankValueFilledIn && (0, _utils.isPresent)(wordAssociation.state.submittedValue)) {
            ary.push(wordAssociation.state.submittedValue.toString());
          }
        });
      }
      return (0, _lodash.uniq)(ary.filter(_utils.isPresent)).join(', ');
    }
  }, {
    key: "exerciseUserInput",
    value: function exerciseUserInput(card) {
      var _this$deck,
        _this6 = this;
      if (!card.exerciseId || !((_this$deck = this.deck) !== null && _this$deck !== void 0 && _this$deck.exercises)) {
        return null;
      }
      var exercise = this.deck.exercises.find(function (item) {
        return item.id === card.exerciseId;
      });
      if (!(exercise !== null && exercise !== void 0 && exercise.exerciseEntries)) {
        return null;
      }
      return exercise.exerciseEntries.map(function (item) {
        return _this6.exerciseEntryUserInput(item);
      }).filter(_utils.isPresent).join(', ');
    }
  }, {
    key: "cardUserInput",
    value: function cardUserInput(card) {
      var _card$cardState, _card$cardState2, _card$cardState3, _card$cardState4;
      var ary = [];
      if ((0, _utils.isPresent)((_card$cardState = card.cardState) === null || _card$cardState === void 0 ? void 0 : _card$cardState.textEntry)) {
        ary.push(card.cardState.textEntry);
      }
      if ((0, _utils.isPresent)((_card$cardState2 = card.cardState) === null || _card$cardState2 === void 0 ? void 0 : _card$cardState2.inputValues)) {
        ary.push((0, _lodash.values)(card.cardState.inputValues).filter(_utils.isPresent).join(', '));
      }
      if ((0, _utils.isPresent)((_card$cardState3 = card.cardState) === null || _card$cardState3 === void 0 ? void 0 : _card$cardState3.selectedOptionText)) {
        ary.push(card.cardState.selectedOptionText);
      }
      if ((0, _utils.isPresent)((_card$cardState4 = card.cardState) === null || _card$cardState4 === void 0 ? void 0 : _card$cardState4.selectedCase)) {
        ary.push(card.cardState.selectedCase);
      }
      var exerciseUserInput = this.exerciseUserInput(card);
      if ((0, _utils.isPresent)(exerciseUserInput)) {
        ary.push(exerciseUserInput);
      }
      return (0, _lodash.uniq)(ary.filter(_utils.isPresent)).join(', ');
    }
  }, {
    key: "userDebugInfo",
    get: function get() {
      var _this$user2, _this$user3, _this$user4, _this$user5, _this$user6, _this$user7, _this$user8, _this$user9;
      return {
        version: (_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.lastWebVersionDownloaded,
        isNative: this.layout.isNative ? '✓' : 'x',
        targetLanguage: this.targetLanguageId,
        deviceOs: this.layout.deviceOs,
        osVersion: this.layout.osVersion,
        osName: this.layout.osName,
        deviceName: this.layout.deviceName,
        deviceManufacturer: this.layout.deviceManufacturer,
        deviceModel: this.layout.deviceModel,
        browserName: this.layout.browserName,
        browserVersion: this.layout.browserVersion,
        viewportWidth: this.layout.viewportWidth,
        viewportHeight: this.layout.viewportHeight,
        hasNotch: this.layout.hasNotch ? '✓' : 'x',
        statusBarHeight: this.layout.statusBarHeight,
        blockMediaAccess: (_this$user3 = this.user) !== null && _this$user3 !== void 0 && _this$user3.blockMediaAccess ? '✓' : 'x',
        vocabCardAudio: (_this$user4 = this.user) !== null && _this$user4 !== void 0 && _this$user4.vocabCardAudio ? '✓' : 'x',
        listeningComprehensionMode: (_this$user5 = this.user) !== null && _this$user5 !== void 0 && _this$user5.listeningComprehensionMode ? '✓' : 'x',
        loopSupplement: (_this$user6 = this.user) !== null && _this$user6 !== void 0 && _this$user6.loopSupplement ? '✓' : 'x',
        supplementMaximized: (_this$user7 = this.user) !== null && _this$user7 !== void 0 && _this$user7.supplementMaximized ? '✓' : 'x',
        showCardAnimation: (_this$user8 = this.user) !== null && _this$user8 !== void 0 && _this$user8.showCardAnimation ? '✓' : 'x',
        currentDayXp: (_this$user9 = this.user) === null || _this$user9 === void 0 ? void 0 : _this$user9.currentDayXp
      };
    }
  }, {
    key: "contactDebugInfo",
    value: function contactDebugInfo() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appVersion = _ref.appVersion,
        platform = _ref.platform;
      return _objectSpread({
        reportType: 'general_contact',
        userInfo: this.userDebugInfo,
        timestamp: new Date().toISOString(),
        appVersion: appVersion
      }, platform && {
        platform: platform
      });
    }
  }, {
    key: "debugInfo",
    get: function get() {
      var _this$deck2,
        _this$deck3,
        _this$deck4,
        _this$deck5,
        _this$userDeck,
        _this$userDeck2,
        _this$userDeck3,
        _this$userDeck4,
        _this$userDeck5,
        _this$userDeck6,
        _this$userDeck7,
        _this$deck6,
        _this$deck7,
        _this7 = this;
      var hsh = {
        userInfo: this.userDebugInfo,
        deckInfo: _objectSpread({
          cardIsAnimating: this.cardIsAnimating ? '✓' : 'x',
          suppressCardSwipeSpring: this.suppressCardSwipeSpring ? '✓' : 'x',
          deckScreenFocused: this.deckScreenFocused ? '✓' : 'x',
          animationRecoveryRevision: this.cardAnimationRecoveryRevision,
          animationNativeMountId: this.cardAnimationNativeMountId,
          deckType: this.hasDeck && ((_this$deck2 = this.deck) === null || _this$deck2 === void 0 || (_this$deck2 = _this$deck2.deckRulebook) === null || _this$deck2 === void 0 ? void 0 : _this$deck2.slug) || 'review',
          languageId: this.hasDeck ? (_this$deck3 = this.deck) === null || _this$deck3 === void 0 ? void 0 : _this$deck3.languageId : null,
          deckId: this.hasDeck ? (_this$deck4 = this.deck) === null || _this$deck4 === void 0 ? void 0 : _this$deck4.id : null,
          deckName: this.hasDeck ? (_this$deck5 = this.deck) === null || _this$deck5 === void 0 ? void 0 : _this$deck5.name : null,
          treeNodeId: this.treeNodeId,
          inTree: (0, _utils.isPresent)(this.treeNodeId),
          userDeckId: (_this$userDeck = this.userDeck) === null || _this$userDeck === void 0 ? void 0 : _this$userDeck.id,
          active: (_this$userDeck2 = this.userDeck) === null || _this$userDeck2 === void 0 || (_this$userDeck2 = _this$userDeck2.userCards) === null || _this$userDeck2 === void 0 ? void 0 : _this$userDeck2.map(function (item) {
            return item.active ? '✓' : 'x';
          }).join(', '),
          seen: (_this$userDeck3 = this.userDeck) === null || _this$userDeck3 === void 0 || (_this$userDeck3 = _this$userDeck3.userCards) === null || _this$userDeck3 === void 0 ? void 0 : _this$userDeck3.map(function (item) {
            return item.seen ? '✓' : 'x';
          }).join(', '),
          correct: (_this$userDeck4 = this.userDeck) === null || _this$userDeck4 === void 0 || (_this$userDeck4 = _this$userDeck4.userCards) === null || _this$userDeck4 === void 0 ? void 0 : _this$userDeck4.map(function (item) {
            return item.correct ? '✓' : 'x';
          }).join(', '),
          completed: (_this$userDeck5 = this.userDeck) === null || _this$userDeck5 === void 0 || (_this$userDeck5 = _this$userDeck5.userCards) === null || _this$userDeck5 === void 0 ? void 0 : _this$userDeck5.map(function (item) {
            return item.completed ? '✓' : 'x';
          }).join(', '),
          position: (_this$userDeck6 = this.userDeck) === null || _this$userDeck6 === void 0 || (_this$userDeck6 = _this$userDeck6.userCards) === null || _this$userDeck6 === void 0 ? void 0 : _this$userDeck6.map(function (item) {
            return item.position;
          }).join(','),
          enriched: ((_this$userDeck7 = this.userDeck) === null || _this$userDeck7 === void 0 ? void 0 : _this$userDeck7.userCards) && ((_this$deck6 = this.deck) === null || _this$deck6 === void 0 || (_this$deck6 = _this$deck6.cards) === null || _this$deck6 === void 0 ? void 0 : _this$deck6.map(function (item) {
            return item.isEnriched ? '✓' : 'x';
          }).join(','))
        }, (0, _utils.isPresent)((_this$deck7 = this.deck) === null || _this$deck7 === void 0 ? void 0 : _this$deck7.trainerParams) && {
          trainerSettings: this.deck.trainerParams
        }),
        cards: [],
        animationCards: []
      };
      (0, _lodash.each)(this.deck.cards, function (item) {
        var _item$word3;
        var translation;
        if (item.translation && item.translation.targetText) {
          translation = item.translation.targetText;
        } else if (item && item.exerciseId && _this7.deck) {
          var exercise = _this7.deck.exercises.find(function (exercise) {
            return exercise.id === item.exerciseId;
          });
          if ((0, _utils.isPresent)(exercise.exerciseEntries)) {
            var _exercise$exerciseEnt;
            translation = exercise === null || exercise === void 0 || (_exercise$exerciseEnt = exercise.exerciseEntries[0]) === null || _exercise$exerciseEnt === void 0 || (_exercise$exerciseEnt = _exercise$exerciseEnt.sentence) === null || _exercise$exerciseEnt === void 0 ? void 0 : _exercise$exerciseEnt.targetText;
          }
        }
        var userCard;
        if ((0, _utils.isPresent)(_this7.userDeck)) {
          userCard = _this7.userDeck.userCards.find(function (uc) {
            return uc.cardId === item.id;
          });
        }
        var userInput = _this7.cardUserInput(item);
        var synonymAssociation = (_item$word3 = item.word) === null || _item$word3 === void 0 || (_item$word3 = _item$word3.synonymAssociations) === null || _item$word3 === void 0 ? void 0 : _item$word3.find(function (association) {
          return association.id === item.synonymAssociationId;
        });
        var synonym = synonymAssociation === null || synonymAssociation === void 0 ? void 0 : synonymAssociation.synonym;
        hsh.cards.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          id: item.id,
          position: item.position,
          translation: translation,
          cardTypeId: item.cardType.id,
          cardTypeSlug: item.cardType.slug
        }, (0, _utils.isPresent)(item.sourceDeckId) && {
          source_deck_id: item.sourceDeckId
        }), (0, _utils.isPresent)(item.synonymAssociationId) && {
          synonym_association_id: item.synonymAssociationId
        }), (0, _utils.isPresent)(synonym === null || synonym === void 0 ? void 0 : synonym.id) && {
          synonym_id: synonym.id
        }), (0, _utils.isPresent)(synonym === null || synonym === void 0 ? void 0 : synonym.targetText) && {
          synonym: synonym.targetTextWithDefiniteArticle || synonym.targetText
        }), {}, {
          correct: userCard && userCard.correct,
          active: userCard && userCard.active,
          completed: userCard && userCard.completed,
          interfaceSource: item.interfaceSource
        }, (0, _utils.isPresent)(item.reviewAfter) && {
          reviewAfter: item.reviewAfter.toString
        }), (0, _utils.isPresent)(item.cardState.textEntry) && {
          text_entry: item.cardState.textEntry
        }), (0, _utils.isPresent)(item.cardState.inputValues) && {
          input_values: (0, _lodash.values)(item.cardState.inputValues).join(', ')
        }), (0, _utils.isPresent)(item.cardState.selectedOptionText) && {
          selected_answer: item.cardState.selectedOptionText
        }), (0, _utils.isPresent)(item.cardState.selectedCase) && {
          selected_case: item.cardState.selectedCase
        }), (0, _utils.isPresent)(userInput) && {
          user_input: userInput
        }));
      });
      (0, _lodash.each)(this.animationCards, function (item) {
        var _item$card$word, _item$cardState, _item$cardState2, _item$card$word2;
        var translation;
        var translationId;
        var translationType;
        var selectedWordAssociations;
        if (item.card && item.card.translation && item.card.translation.targetText) {
          translation = item.card.translation.targetText;
          translationId = item.card.translation.id;
          translationType = item.card.translationType;
          if ((0, _utils.isPresent)(item.card.wordAssociationIds) && (0, _utils.isPresent)(item.card.translation.wordAssociations)) {
            selectedWordAssociations = item.card.translation.wordAssociations.filter(function (wordAssociation) {
              return item.card.wordAssociationIds.includes(wordAssociation.id);
            });
          }
        } else if (item.card && item.card.exerciseId && _this7.deck) {
          var exercise = _this7.deck.exercises.find(function (exercise) {
            return exercise.id === item.card.exerciseId;
          });
          if ((0, _utils.isPresent)(exercise.exerciseEntries)) {
            var _exercise$exerciseEnt2;
            translation = exercise === null || exercise === void 0 || (_exercise$exerciseEnt2 = exercise.exerciseEntries[0]) === null || _exercise$exerciseEnt2 === void 0 || (_exercise$exerciseEnt2 = _exercise$exerciseEnt2.sentence) === null || _exercise$exerciseEnt2 === void 0 ? void 0 : _exercise$exerciseEnt2.targetText;
          }
        }
        // Get expected answer for conjugation cards
        var expectedAnswer;
        if ((0, _utils.isPresent)(item.card.pronoun) && (0, _utils.isPresent)(item.card.tenseConceptId) && (0, _utils.isPresent)((_item$card$word = item.card.word) === null || _item$card$word === void 0 ? void 0 : _item$card$word.conjugatedVerbStrings)) {
          var pronounField = item.card.pronoun.replace('_', '');
          var conjugatedVerbString = item.card.word.conjugatedVerbStrings.find(function (cvs) {
            return cvs.conceptId === item.card.tenseConceptId;
          });
          if (conjugatedVerbString && conjugatedVerbString[pronounField]) {
            expectedAnswer = conjugatedVerbString[pronounField].replace(/'/, '\' ').replace(/\s+/, ' ');
          }
        }
        var selectedAnswer = (_item$cardState = item.cardState) === null || _item$cardState === void 0 ? void 0 : _item$cardState.selectedOptionText;
        var multipleChoiceOptions = item.card.multipleChoiceOptions || _this7.pluralMultipleChoiceOptions(item.card);
        var multipleChoiceOptionsText = ((_item$cardState2 = item.cardState) === null || _item$cardState2 === void 0 ? void 0 : _item$cardState2.multipleChoiceOptionsText) || (multipleChoiceOptions === null || multipleChoiceOptions === void 0 ? void 0 : multipleChoiceOptions.map(function (option) {
          return _this7.optionText(option);
        }).join(', '));
        var synonymAssociation = (_item$card$word2 = item.card.word) === null || _item$card$word2 === void 0 || (_item$card$word2 = _item$card$word2.synonymAssociations) === null || _item$card$word2 === void 0 ? void 0 : _item$card$word2.find(function (association) {
          return association.id === item.card.synonymAssociationId;
        });
        var synonym = synonymAssociation === null || synonymAssociation === void 0 ? void 0 : synonymAssociation.synonym;
        if (item.userCard.cardRule.cardType.slug === 'plural') {
          var _item$cardState3;
          console.log('DeckUI plural debugInfo options debug', {
            cardId: item.card.id,
            selectedAnswer: selectedAnswer,
            cardStateMultipleChoiceOptionsText: (_item$cardState3 = item.cardState) === null || _item$cardState3 === void 0 ? void 0 : _item$cardState3.multipleChoiceOptionsText,
            multipleChoiceOptions: multipleChoiceOptions,
            multipleChoiceOptionsText: multipleChoiceOptionsText,
            word: item.card.word,
            translation: item.card.translation
          });
        }
        hsh.animationCards.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          position: item.position,
          animateCard: item.animateCard ? '✓' : 'x',
          cardId: item.card.id,
          userCardId: item.userCard.id,
          userCardPosition: item.userCard.position,
          userCardActive: item.userCard.active ? '✓' : 'x',
          cardType: item.userCard.cardRule.cardType.slug,
          translation: translation,
          translationId: translationId,
          translationType: translationType
        }, (0, _utils.isPresent)(item.card.synonymAssociationId) && {
          synonym_association_id: item.card.synonymAssociationId
        }), (0, _utils.isPresent)(synonym === null || synonym === void 0 ? void 0 : synonym.id) && {
          synonym_id: synonym.id
        }), (0, _utils.isPresent)(synonym === null || synonym === void 0 ? void 0 : synonym.targetText) && {
          synonym: synonym.targetTextWithDefiniteArticle || synonym.targetText
        }), (0, _utils.isPresent)(selectedWordAssociations) && {
          selected_word_associations: selectedWordAssociations.map(function (item) {
            return item.targetText;
          }).join(', ')
        }), (0, _utils.isPresent)(multipleChoiceOptionsText) && {
          multiple_choice_options: multipleChoiceOptionsText
        }), (0, _utils.isPresent)(selectedAnswer) && {
          selected_answer: selectedAnswer
        }), (0, _utils.isPresent)(item.card.pronoun) && {
          pronoun: item.card.pronoun
        }), (0, _utils.isPresent)(item.card.tenseConceptId) && {
          tense_concept_id: item.card.tenseConceptId
        }), (0, _utils.isPresent)(expectedAnswer) && {
          expected_answer: expectedAnswer
        }));
      });
      return hsh;
    }
  }, {
    key: "wordSentences",
    get: function get() {
      return this.wordSentenceStore.indexData;
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      return (0, _utils.isPresent)(this.user.id);
    }
  }, {
    key: "hasDeck",
    get: function get() {
      return (0, _utils.isPresent)(this.deck);
    }
  }, {
    key: "hasUserDeck",
    get: function get() {
      return (0, _utils.isPresent)(this.userDeck);
    }
  }, {
    key: "hasCurrentCard",
    get: function get() {
      return (0, _utils.isPresent)(this.currentCard);
    }

    // DECK STATE
  }, {
    key: "showCorrectCardStatus",
    get: function get() {
      return false;
    }
  }, {
    key: "levelIncremented",
    get: function get() {
      return this.deckState && this.deckState.currentAnimation === 'levelIncremented';
    }
  }, {
    key: "setCardIsAnimating",
    value: function setCardIsAnimating(cardIsAnimating) {
      this.cardIsAnimating = cardIsAnimating;
      if (!cardIsAnimating) {
        this.firstCardHasAdvanced = true;
        this.arrowBoxIsHidden = false;
      }
    }
  }, {
    key: "setSkipCardAnimation",
    value: function setSkipCardAnimation(skipCardAnimation) {
      this.skipCardAnimation = skipCardAnimation;
    }
  }, {
    key: "assignShortcut",
    value: function assignShortcut(shortcut) {
      if (!this.isShortcutAssigned(shortcut)) {
        this.shortcutsAssigned.push(shortcut);
      }
    }
  }, {
    key: "removeShortcut",
    value: function removeShortcut(shortcut) {
      this.shortcutsAssigned = (0, _lodash.without)(this.shortcutsAssigned, shortcut);
    }
  }, {
    key: "isShortcutAssigned",
    value: function isShortcutAssigned(shortcut) {
      return this.shortcutsAssigned.includes(shortcut);
    }
  }, {
    key: "skipAnimationGotoLastCard",
    value: function skipAnimationGotoLastCard() {
      var _this8 = this;
      var resetPromise = Promise.resolve();
      if (this.userInputStore && (0, _lodash.isFunction)(this.userInputStore.resetForNewRecording)) {
        resetPromise = Promise.resolve(this.userInputStore.resetForNewRecording());
      }
      return resetPromise.then(function () {
        return _this8.finishSkipAnimationGotoLastCard();
      });
    }
  }, {
    key: "finishSkipAnimationGotoLastCard",
    value: function finishSkipAnimationGotoLastCard() {
      this.onSoftReset();
      this.setSkipCardAnimation(true);
      this.gotoPreviousCard();
    }
  }, {
    key: "skipAnimationNextCard",
    value: function skipAnimationNextCard() {
      var _this$currentUserCard;
      if (!this.isLastCard && (0, _lodash.isFunction)((_this$currentUserCard = this.currentUserCard) === null || _this$currentUserCard === void 0 ? void 0 : _this$currentUserCard.set)) {
        this.onSoftReset();
        this.setSkipCardAnimation(true);
        this.currentUserCard.set('currentCorrect', true);
        this.currentUserCard.set('correct', true);
        this.advanceCard(this.currentCard, this.currentCardState, this.currentUserCard, {
          active: false,
          forceAdvancement: true
        });
      }
    }
  }, {
    key: "vocabSectionHeight",
    get: function get() {
      var height = this.wordOptionsCard ? this.layout.contentHeight - this.layout.userInputHeight : this.layout.contentHeight;
      return Math.floor(height / this.numVocabSections);
    }
  }, {
    key: "numVocabSections",
    get: function get() {
      return this.wordOptionsCard || this.vocabSentenceTranslateAudioCard && !this.currentCardRevealed ? 2 : 3;
    }
  }, {
    key: "vocabTextHeight",
    get: function get() {
      return this.vocabSectionHeight - 20;
    }
  }, {
    key: "onToggleReview",
    value: function onToggleReview(card, reviewDeckId) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (card.cardState && !params.hideMessage) {
        if (card.cardState.set) {
          card.cardState.set('addToReviews', !(card.cardState.addToReviews || (0, _utils.isPresent)(this.reviewCard(card))));
        } else {
          card.cardState.addToReviews = !(card.cardState.addToReviews || (0, _utils.isPresent)(this.reviewCard(card)));
        }
      }
      if ((0, _utils.isPresent)(this.reviewCard(card, reviewDeckId))) {
        this.cardStore.destroy({
          ids: {
            cardId: this.reviewCard(card, reviewDeckId).id
          }
        });
        this.removeCardFromReviewCards(card, reviewDeckId);
        if (card.set) {
          card.set('reviewCardId', null);
        } else {
          card.reviewCardId = null;
        }
      } else {
        this.user.set('reviewCardsCount', this.user.reviewCardsCount + 1);
        if (card.set) {
          card.set('reviewCardId', '999');
        } else {
          card.reviewCardId = '999';
        }
        if (card.word) {
          if (card.word.set) {
            card.word.set('reviewing', true);
          } else {
            card.word.reviewing = true;
          }
        }
        this.addCardToReviewCards(card, reviewDeckId);
        this.cardStore.create({
          data: {
            source_card_id: card.id,
            synonym_association_id: card.synonymAssociationId,
            deck_id: reviewDeckId,
            language_id: this.deck.languageId
          }
        }, this.afterCreateReview.bind(this, card, reviewDeckId));
      }
    }
  }, {
    key: "createEventOnServer",
    value: function createEventOnServer(eventType, params) {
      var _this9 = this;
      this.eventStore.create({
        data: {
          eventType: eventType,
          params: params
        },
        failureCallback: function failureCallback(err) {
          if (_this9.logger) {
            _this9.logger.warn('Event creation failed', {
              eventType: eventType,
              error: err
            });
          } else {
            console.warn('Event creation failed', eventType, err);
          }
        }
      }, _lodash.noop);
    }
  }, {
    key: "afterCreateReview",
    value: function afterCreateReview(card, deckId, resp) {
      var _card$word2,
        _card$sentence2,
        _this0 = this;
      card.set('reviewCardId', resp.cardId);
      var cardTranslationId = ((_card$word2 = card.word) === null || _card$word2 === void 0 ? void 0 : _card$word2.id) || ((_card$sentence2 = card.sentence) === null || _card$sentence2 === void 0 ? void 0 : _card$sentence2.id);
      (0, _lodash.each)(this.reviewCards, function (item) {
        if (((0, _utils.isPresent)(cardTranslationId) && item.translationId === cardTranslationId || (0, _utils.isPresent)(card.exerciseId) && item.sourceCardId === card.id) && item.deckId === deckId && item.cardTypeId === card.cardTypeId && _this0.reviewCardMatchesSynonymAssociation(card, item)) {
          item.id = resp.cardId;
        }
      });
    }
  }, {
    key: "onEvaluateTextInput",
    value: function onEvaluateTextInput(card, cardState, userCard) {
      var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      userCard.set('correct', false);
      userCard.set('firstAnswerCorrect', false);
      this.vocabStuckClicked = false;
      var word = card.word;
      var normalizedTextEntry = word ? this.normalizeString(cardState.textEntry) : null;
      var match = this.getEvaluateTextInputMatch(word, cardState);
      var correct = (card.vocabWordTranslateCard || card.numberTranslateCard) && match;
      var noAccentMatch;
      var missingArticle;
      var wrongArticle;
      if ((0, _utils.isPresent)(word)) {
        noAccentMatch = !correct && word && cardState.textEntry && (0, _utils.isPresent)(normalizedTextEntry) && ((0, _lodash.deburr)(normalizedTextEntry.replace('-', ' ')) === (0, _lodash.deburr)(this.normalizeString(word.targetTextWithDefiniteArticle).replace(/-/g, ' ')) || word.useParenthesesOnGender && (0, _lodash.deburr)(normalizedTextEntry) === (0, _lodash.deburr)(this.normalizeString(word.targetText)));

        // check if article is missing
        var articles = (0, _lodash.uniq)((0, _lodash.values)(_constants.Constants.SINGULAR_ARTICLES[word.languageId]).concat((0, _lodash.values)(_constants.Constants.PLURAL_ARTICLES[word.languageId])));
        var maxArticleLength = Math.max.apply(Math, _toConsumableArray(articles.map(function (item) {
          return item.length;
        })));
        var pattern;
        if (word.languageId === 'FR') {
          pattern = new RegExp("^((".concat(articles.join('|'), ")\\s+|l'|l\u2019|l\u2018)"));
        } else {
          pattern = new RegExp("^(".concat(articles.join('|'), ")\\s+"));
        }
        missingArticle = word && word.isNoun && !(word.useParenthesesOnGender || word.articleIsHidden) && cardState.textEntry.length > maxArticleLength && !pattern.test(cardState.textEntry.toLowerCase());
        wrongArticle = word && word.isNoun && !correct && !missingArticle && (0, _utils.isPresent)(normalizedTextEntry) && normalizedTextEntry.replace(pattern, '') === this.normalizeString(word.targetText);
      }
      var allLowerCaseMatch = !correct && this.getEvaluateTextInputMatch(word, cardState, true);

      // warning messages stored in constants.js
      if ((0, _utils.isPresent)(word)) {
        if (missingArticle) {
          this.warning = !params.onlyRevealOnCorrect && this.warning === 'missingArticle' ? '' : 'missingArticle';
        } else if (wrongArticle) {
          this.warning = !params.onlyRevealOnCorrect && this.warning === 'wrongArticle' ? '' : 'wrongArticle';
        } else if (noAccentMatch) {
          this.warning = !params.onlyRevealOnCorrect && this.warning === 'accents' ? '' : 'accents';
        } else if (this.textEntryMatchesSynonym(word, cardState)) {
          this.warning = !params.onlyRevealOnCorrect && this.warning === 'synonym' ? '' : 'synonym';
        } else if (allLowerCaseMatch) {
          this.warning = !params.onlyRevealOnCorrect && this.warning === 'letterCase' ? '' : 'letterCase';
        } else {
          this.warning = '';
        }
      }
      if (correct) {
        this.warning = '';
        this.onCorrectAnswer(card, cardState, userCard, {
          xp: 2
        });
      } else if (!params.onlyRevealOnCorrect && (0, _utils.isBlank)(this.warning)) {
        this.onIncorrectAnswer(card, cardState, userCard);
      }
      if ((!params.onlyRevealOnCorrect || correct) && (0, _utils.isBlank)(this.warning)) {
        this.reveal(card, cardState);
      }
      if (correct && normalizedTextEntry !== this.normalizeString(word.targetTextWithDefiniteArticle) && normalizedTextEntry !== this.normalizeString(word.targetTextWithDefiniteArticleNoParenthesis) && normalizedTextEntry !== this.normalizeString(word.targetText)) {
        this.showCorrectAnswer = true;
      } else {
        this.showCorrectAnswer = false;
      }
    }
  }, {
    key: "onWordInputChange",
    value: function onWordInputChange(cardState, val) {
      if (cardState) {
        val = val.replace('’', '\'');
        cardState.set('textEntry', val);
      }
    }
  }, {
    key: "onWordInputChangeAndEvaluate",
    value: function onWordInputChangeAndEvaluate(card, cardState, userCard, val) {
      if (cardState) {
        val = val.replace('’', '\'');
        cardState.set('textEntry', val);
      }
      this.onEvaluateTextInput(card, cardState, userCard, {
        onlyRevealOnCorrect: true
      });
    }

    // ephemeral cards
  }, {
    key: "checkpointCard",
    get: function get() {
      return this.currentCardSlug === 'checkpoint_card';
    }
  }, {
    key: "wordOptionsCard",
    get: function get() {
      return this.currentCardSlug === 'vocab_word_options';
    }

    // static cards
  }, {
    key: "deckSummaryCard",
    get: function get() {
      return this.currentCardSlug === 'deck_summary';
    }
  }, {
    key: "triviaCard",
    get: function get() {
      return this.currentCardSlug === 'trivia';
    }
  }, {
    key: "genderCard",
    get: function get() {
      return this.currentCardSlug === 'gender';
    }
  }, {
    key: "genderResultsCard",
    get: function get() {
      return this.currentCardSlug === 'gender-results';
    }
  }, {
    key: "conjugationResultsCard",
    get: function get() {
      return this.currentCardSlug === 'conjugation-results';
    }
  }, {
    key: "pluralCard",
    get: function get() {
      return this.currentCardSlug === 'plural';
    }
  }, {
    key: "pluralResultsCard",
    get: function get() {
      return this.currentCardSlug === 'plural-results';
    }
  }, {
    key: "synonymResultsCard",
    get: function get() {
      return this.currentCardSlug === 'synonym-results';
    }
  }, {
    key: "caseResultsCard",
    get: function get() {
      return this.currentCardSlug === 'case-results';
    }
  }, {
    key: "numberResultsCard",
    get: function get() {
      return this.currentCardSlug === 'number-results';
    }
  }, {
    key: "triviaIntroCard",
    get: function get() {
      return this.currentCardSlug === 'trivia-intro';
    }
  }, {
    key: "triviaResultsCard",
    get: function get() {
      return this.currentCardSlug === 'trivia-results';
    }
  }, {
    key: "describeCard",
    get: function get() {
      return this.currentCardSlug === 'record_description';
    }
  }, {
    key: "answerCard",
    get: function get() {
      return this.currentCardSlug === 'record_answer';
    }
  }, {
    key: "comprehendCard",
    get: function get() {
      return this.currentCardSlug === 'comprehend';
    }
  }, {
    key: "translateCard",
    get: function get() {
      return this.currentCardSlug === 'translate';
    }
  }, {
    key: "exerciseCard",
    get: function get() {
      return this.currentCardSlug === 'exercise';
    }
  }, {
    key: "vocabWordComprehendCard",
    get: function get() {
      return this.currentCardSlug === 'vocab_word_comprehend';
    }
  }, {
    key: "vocabSentenceTranslateCard",
    get: function get() {
      return this.currentCardSlug === 'vocab_sentence_translate';
    }
  }, {
    key: "vocabSentenceComprehendCard",
    get: function get() {
      return this.currentCardSlug === 'vocab_sentence_comprehend';
    }
  }, {
    key: "vocabSentenceTranslateAudioCard",
    get: function get() {
      return this.vocabSentenceTranslateCard && this.vocabCardUsesAudio;
    }

    // ---------------
  }, {
    key: "userDeckGenderCards",
    get: function get() {
      var ids = this.deck.genderCards.map(function (item) {
        return item.id;
      });
      return this.userDeck.userCards.filter(function (item) {
        return ids.includes(item.cardId);
      });
    }
  }, {
    key: "userDeckPluralCards",
    get: function get() {
      var ids = this.deck.pluralCards.map(function (item) {
        return item.id;
      });
      return this.userDeck.userCards.filter(function (item) {
        return ids.includes(item.cardId);
      });
    }
  }, {
    key: "userDeckNumberCards",
    get: function get() {
      var ids = this.deck.numberCards.map(function (item) {
        return item.id;
      });
      return this.userDeck.userCards.filter(function (item) {
        return ids.includes(item.cardId);
      });
    }
  }, {
    key: "userDeckTriviaCards",
    get: function get() {
      var ids = this.deck.triviaCards.map(function (item) {
        return item.id;
      });
      return this.userDeck.userCards.filter(function (item) {
        return ids.includes(item.cardId);
      });
    }
  }, {
    key: "deviceType",
    get: function get() {
      if (this.layout.isAndroid) {
        return 'android';
      } else if (this.layout.isIos) {
        return 'ios';
      }
      return 'web';
    }
  }, {
    key: "loadDeck",
    value: function loadDeck(params) {
      var _this1 = this;
      var deckLoadRequestId = ++this.deckLoadRequestId;
      this.onNewDeck();
      this.onReset();
      this.deckStore.clearShowData();
      this.userDeckStore.clearShowData();
      clearTimeout(this.checkLoadTimeTimeout);
      this.checkLoadTimeTimeout = setTimeout(function () {
        return _this1.checkDeckLoadTime();
      }, _constants.Constants.SLOW_REQUEST_WARNING_TIMEOUT);
      this.loadDeckStartTime = performance.now();
      this.deckStore.getShow({
        ids: {
          deckId: params.id
        },
        queryStrings: {
          device: this.deviceType,
          optimize_deck: true,
          // only applies to triva, but one entry point more important than making sure we only pass this querystring for trivia
          tree_node_id: params.treeNodeId
        }
      }, this.afterLoadDeck.bind(this, params.userDeckId, params.opponentId, params.cardId, deckLoadRequestId, params.callback || _lodash.noop));
    }
  }, {
    key: "cancelDeckLoad",
    value: function cancelDeckLoad() {
      this.deckLoadRequestId += 1;
      clearTimeout(this.checkLoadTimeTimeout);
      this.showSlowDeckLoadingWarning = false;
    }
  }, {
    key: "checkDeckLoadTime",
    value: function checkDeckLoadTime() {
      if (!this.hasDeck) {
        this.showSlowDeckLoadingWarning = true;
      }
    }
  }, {
    key: "afterLoadDeck",
    value: function afterLoadDeck(userDeckId, opponentId, cardId, deckLoadRequestId, callback, resp) {
      if (deckLoadRequestId !== this.deckLoadRequestId) {
        return;
      }
      if (callback !== undefined) {
        callback(resp);
      }
      clearTimeout(this.checkLoadTimeTimeout);
      this.showSlowDeckLoadingWarning = false;
      this.deckStore.setShowData(resp);
      this.createUserInputStores();
      this.userDeckStore.create({
        queryStrings: {
          user_deck_id: userDeckId,
          opponent_id: opponentId
        },
        data: {
          deckId: resp.id
        }
      }, this.afterCreateUserDeck.bind(this, cardId, deckLoadRequestId));
      this.getReviewCards();
      if (this.deck.deckType === 'review' && this.deck.reviewsFilterDue !== 'past-due') {
        var text = this.deck.reviewsFilterDue === 'retired' ? 'This deck features only retired reviews.' : 'This deck features only already caught up reviews.';
        this.setCardNotice({
          timeout: 10000,
          text: text,
          buttonText: 'Show Current Reviews',
          onClick: this.resetReviewsDeckFilter,
          background: '#FFF',
          color: '#333',
          border: "4px solid ".concat(_constants.Theme.green)
        });
      }
      if (this.deck.caseDeck && this.layout.isNative) {
        this.designateUiElementAsSeen('vocabDeckNew_case');
      }
      this.createEvent('deck - open deck', {
        language_id: resp.languageId,
        deck_id: resp.id,
        deck_type: this.deckTypeForAnalytics(resp)
      });
    }
  }, {
    key: "afterCreateUserDeck",
    value: function afterCreateUserDeck(cardId, deckLoadRequestId, resp) {
      var _this$deck8;
      if (deckLoadRequestId !== this.deckLoadRequestId || !((_this$deck8 = this.deck) !== null && _this$deck8 !== void 0 && _this$deck8.cards)) {
        return;
      }
      this.userDeckStore.setShowData(resp);
      var selectedCard = this.deck.cards.find(function (card) {
        return card.id === cardId;
      });
      var selectedUserCard = this.userDeck.userCards.find(function (userCard) {
        return userCard.cardId === cardId;
      });
      if (selectedCard && selectedUserCard) {
        var userDeckId = this.userDeck.id;
        this.userDeck.gotoCard(cardId);
        this.userDeckStore.update({
          ids: {
            userDeckId: userDeckId
          },
          data: {
            current_card_id: cardId
          },
          failureCallback: this.completeUserDeckLoadIfCurrent.bind(this, deckLoadRequestId),
          onRequestError: this.completeUserDeckLoadIfCurrent.bind(this, deckLoadRequestId)
        }, this.afterSelectCard.bind(this, deckLoadRequestId, userDeckId));
        return;
      }
      this.completeUserDeckLoad();
    }
  }, {
    key: "storyDeck",
    get: function get() {
      return this.hasDeck && this.deck.deckRulebook && ['story', 'conversations', 'questions', 'gif', 'exercise', 'default', 'story-comprehension-linear', 'story-comprehension-mixed', 'story-comprehension-question'].includes(this.deck.deckRulebook.slug);
    }
  }, {
    key: "vocabDeck",
    get: function get() {
      return this.hasDeck && this.deck.deckRulebook && this.deck.deckRulebook.slug === 'vocab';
    }
  }, {
    key: "showVocabExampleSentences",
    get: function get() {
      return Boolean(this.hasDeck && (this.reviewDeck || this.vocabDeck || this.deck.synonymDeck));
    }
  }, {
    key: "correctCardsStatusCards",
    get: function get() {
      if (this.deck.genderDeck) {
        return this.userDeckGenderCards;
      }
      if (this.deck.pluralDeck) {
        return this.userDeckPluralCards;
      }
      if (this.deck.numberDeck) {
        return this.userDeckNumberCards;
      }
      if (this.deck.triviaDeck) {
        return this.userDeckTriviaCards;
      }
    }
  }, {
    key: "currentSentence",
    get: function get() {
      var _this$currentCard, _this$currentCard$sen, _this$currentCard2;
      if ((_this$currentCard = this.currentCard) !== null && _this$currentCard !== void 0 && _this$currentCard.triviaCard && (_this$currentCard$sen = this.currentCard.sentence) !== null && _this$currentCard$sen !== void 0 && _this$currentCard$sen.answer) {
        var _this$currentCard$sen2;
        return (_this$currentCard$sen2 = this.currentCard.sentence) === null || _this$currentCard$sen2 === void 0 ? void 0 : _this$currentCard$sen2.answer;
      }
      return (_this$currentCard2 = this.currentCard) === null || _this$currentCard2 === void 0 ? void 0 : _this$currentCard2.sentence;
    }
  }, {
    key: "currentWord",
    get: function get() {
      var _this$currentCard3;
      return (_this$currentCard3 = this.currentCard) === null || _this$currentCard3 === void 0 ? void 0 : _this$currentCard3.word;
    }
  }, {
    key: "currentCardRevealed",
    get: function get() {
      return this.isLastCard || this.currentCardState.revealed || this.comprehendCard && !this.user.listeningComprehensionMode;
    }
  }, {
    key: "showDeckGrammar",
    get: function get() {
      return this.hasDeck && this.hasUserDeck && !this.showAncillaryCard && (this.deck.hasCombinedGrammarDescription || this.deck.hasCombinedDescription);
    }
  }, {
    key: "previousCard",
    get: function get() {
      var _this10 = this;
      if (this.deck && this.deck.cards && !this.userDeck.currentUserCardIsFirstInDeck) {
        var card = this.deck.cards.find(function (item) {
          return item.position === _this10.userDeck.currentPosition - 1;
        });
        return card;
      }
    }
  }, {
    key: "deckLoaded",
    get: function get() {
      return !this.deckStore.outstandingRequests && (0, _utils.isPresent)(this.deck) && (0, _utils.isPresent)(this.userDeck) && this.authUserStore.hasShowData;
    }

    // XP
  }, {
    key: "adjustedDefaultXp",
    get: function get() {
      return this.reviewDeck ? _constants.Constants.XP_CARD_REVIEW : _constants.Constants.XP_CARD_DEFAULT;
    }
  }, {
    key: "onHideArrowBox",
    value: function onHideArrowBox() {
      this.arrowBoxIsHidden = true;
    }
  }, {
    key: "designateUiElementAsSeen",
    value: function designateUiElementAsSeen(uiElement) {
      if ((0, _utils.isPresent)(uiElement) && this.userIsLoaded && !this.user.wasUiElementSeen(uiElement)) {
        this.user.designateUiElementAsSeen(uiElement);
        this.authUserStore.update({
          data: {
            ui_elements_seen: this.user.uiElementsSeen
          }
        });
      }
    }
  }, {
    key: "onDeleteReview",
    value: function onDeleteReview() {
      _overlay_ui["default"].clearOverlays();
      var cardId = this.currentCard.id;
      this.advanceCard(this.currentCard, this.currentCardState, this.currentUserCard, {
        forceAdvancement: true
      });
      this.cardStore.destroy({
        ids: {
          cardId: cardId
        }
      });
    }
  }, {
    key: "onSnoozeReview",
    value: function onSnoozeReview() {
      _overlay_ui["default"].clearOverlays();
      this.cardStore.snooze({
        ids: {
          cardId: this.currentCard.id
        }
      });
      this.advanceCard(this.currentCard, this.currentCardState, this.currentUserCard);
    }

    // SUPPLEMENT
  }, {
    key: "supplementMaximized",
    get: function get() {
      if (this.currentCardState.showHelp || !this.showDeckSupplement || this.translateCard && !this.currentCardRevealed && !this.currentCardState.showHelp) {
        return false;
      }
      if (!this.showVideoPlayer) {
        return true;
      }
      return this.user.supplementMaximized;
    }
  }, {
    key: "showDeckSupplement",
    get: function get() {
      return this.hasSupplementMedia && !this.isLastCard && !this.interjectionCard && !this.currentCardState.showHelp && (this.currentCardRevealed || !this.translateCard) && (this.currentCard.showSupplement || this.reviewDeck);
    }
  }, {
    key: "hasSupplementMedia",
    get: function get() {
      return this.currentCard && (this.currentCard.hasSupplementImage || this.currentCard.hasSupplementVideoClip);
    }

    // CARD STATE
  }, {
    key: "interjectionCard",
    get: function get() {
      return this.currentCardSlug === 'interjection';
    }
  }, {
    key: "cardType",
    get: function get() {
      if (this.hasCurrentCard) {
        return this.currentCardSlug;
      }
    }
  }, {
    key: "userResponseCard",
    get: function get() {
      return this.describeCard || this.answerCard;
    }
  }, {
    key: "vocabWordTranslateCard",
    get: function get() {
      return this.currentCardSlug === 'vocab_word_translate';
    }
  }, {
    key: "vocabCardUsesAudio",
    get: function get() {
      return this.canRecordMedia && this.user.vocabCardAudio;
    }
  }, {
    key: "vocabCard",
    get: function get() {
      return this.vocabWordTranslateCard || this.vocabWordComprehendCard || this.vocabSentenceTranslateCard || this.vocabSentenceComprehendCard;
    }
  }, {
    key: "showUserInput",
    get: function get() {
      return this.layout.showUserInput && this.canRecordMedia && this.hasUserDeck;
    }
  }, {
    key: "showNoUserInputBar",
    get: function get() {
      return !this.showUserInput && !this.vocabCard && !this.triviaCard && !this.genderCard && !this.isLastCard && !this.interjectionCard;
    }
  }, {
    key: "isSecondToLastCard",
    get: function get() {
      return this.deck.hasCards && this.userDeck.numActiveUserCards <= 3 && !this.showAncillaryCard;
    }
  }, {
    key: "isFirstCard",
    get: function get() {
      return this.deck.hasCards && this.userDeck.numActiveUserCards === this.deck.cards.length;
    }
  }, {
    key: "showDeckHeader",
    get: function get() {
      return this.hasDeck && this.hasUserDeck;
    }
  }, {
    key: "showLoadingIcon",
    get: function get() {
      return !this.hasDeck || !this.hasUserDeck || !this.showAncillaryCard && this.userIsLoaded && (!this.localDeck && this.deckStore.showLoadingIcon || this.deckStore.outstandingRequests);
    }
  }, {
    key: "showDeckGrammarIcon",
    get: function get() {
      return this.hasDeck && this.deck.showDeckGrammarCard && !this.showLoadingIcon && (this.deck.hasGrammarDescription || this.deck.hasTreeNodeGrammarDescription);
    }
  }, {
    key: "showVideoPlayer",
    get: function get() {
      return this.videoPossible && (this.comprehendCard || this.interjectionCard || this.currentCardRevealed);
    }
  }, {
    key: "videoPossible",
    get: function get() {
      return this.deckLoaded && (0, _utils.isPresent)(this.currentCard) && this.currentCard.hasTargetVideoClip;
    }
  }, {
    key: "playsVideoBeforeReveal",
    value: function playsVideoBeforeReveal(card) {
      return Boolean((card === null || card === void 0 ? void 0 : card.comprehendCard) || (card === null || card === void 0 ? void 0 : card.vocabWordComprehendCard) || (card === null || card === void 0 ? void 0 : card.vocabSentenceComprehendCard));
    }
  }, {
    key: "willAutoPlayVideoOnReveal",
    value: function willAutoPlayVideoOnReveal(card) {
      return Boolean((card === null || card === void 0 ? void 0 : card.hasTargetVideoClip) && !this.playsVideoBeforeReveal(card));
    }
  }, {
    key: "playUserInputRecording",
    value: function playUserInputRecording() {
      var _card;
      var card = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var cardState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!card) {
        card = this.currentCard;
      }
      if (!cardState) {
        cardState = this.currentCardState;
      }
      if (!this.canRecordMedia || !cardState || cardState.audioHasAutoPlayed) {
        return;
      }
      var store = (_card = card) !== null && _card !== void 0 && _card.id ? this.userInputStores[card.id] : null;
      if (!store || !(0, _lodash.isFunction)(store.play)) {
        return;
      }
      if (!store.hasFinishedRecording && !store.hasRecording && !store.hasNativeSound) {
        return;
      }
      cardState.set('audioHasAutoPlayed', true);
      setTimeout(store.play, 10);
    }
  }, {
    key: "playUserInputAfterRevealVideo",
    value: function playUserInputAfterRevealVideo(card, cardState) {
      if (!(cardState !== null && cardState !== void 0 && cardState.revealed)) {
        return;
      }
      if (this.layout.isNative && !cardState.videoPlaying && !cardState.videoHasAutoPlayed) {
        return;
      }
      this.playUserInputRecording(card, cardState);
    }
  }, {
    key: "reveal",
    value: function reveal() {
      var _card3;
      var card = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var cardState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (this.logger) {
        var _card2, _this$currentCard4;
        this.logger.debug('Reveal called', {
          cardId: ((_card2 = card) === null || _card2 === void 0 ? void 0 : _card2.id) || ((_this$currentCard4 = this.currentCard) === null || _this$currentCard4 === void 0 ? void 0 : _this$currentCard4.id)
        });
      }
      if (!card) {
        card = this.currentCard;
      }
      if (!cardState) {
        cardState = this.currentCardState;
      }
      if (this.layout.isNative && (0, _lodash.isFunction)(this.nativeKeyboardDismiss)) {
        this.nativeKeyboardDismiss();
      }
      if (this.layout.isNative && this.canRecordMedia && (_card3 = card) !== null && _card3 !== void 0 && _card3.id) {
        var _this$userInputStores3;
        (_this$userInputStores3 = this.userInputStores[card.id]) === null || _this$userInputStores3 === void 0 || _this$userInputStores3.stopRecording();
      }
      if ((0, _utils.isPresent)(cardState) && !cardState.revealed) {
        cardState.set('pendingReveal', false);
        cardState.set('revealed', true);
        this.lastRevealAt = Date.now();
        if (!this.willAutoPlayVideoOnReveal(card)) {
          this.playUserInputRecording(card, cardState);
        }
      }
      this.arrowBoxIsHidden = false;
      if (this.layout.isNative && !this.cardIsAnimating) {
        this.ensureCurrentAnimationCardIsVisible();
      }
    }
  }, {
    key: "onRevealVideoReady",
    value: function onRevealVideoReady(card, cardState) {
      if (!cardState) {
        return;
      }
      cardState.set('videoReady', true);
    }
  }, {
    key: "onRevealVideoPlaying",
    value: function onRevealVideoPlaying(card, cardState) {
      if (!cardState) {
        return;
      }
      cardState.set('videoReady', true);
      cardState.set('videoPlaying', true);
      cardState.set('videoHasAutoPlayed', true);
    }
  }, {
    key: "onRevealVideoEnded",
    value: function onRevealVideoEnded(card, cardState) {
      if (!cardState) {
        return;
      }
      var videoDidPlay = Boolean(cardState.videoPlaying || cardState.videoHasAutoPlayed);
      cardState.set('videoPlaying', false);
      cardState.set('videoHasAutoPlayed', true);
      if (cardState.revealed && videoDidPlay) {
        this.playUserInputRecording(card, cardState);
      }
    }
  }, {
    key: "revealText",
    value: function revealText(card, cardState) {
      this.reveal(card, cardState);
      this.textRevealed = true;
    }

    // CARD BUTTONS
  }, {
    key: "currentCardSlug",
    get: function get() {
      return this.currentCard && this.currentCard.cardTypeSlug;
    }
  }, {
    key: "releaseTimeoutGotoNextCard",
    value: function releaseTimeoutGotoNextCard(card, cardState, userCard) {
      this.onSoftReset();
      this.advanceCard(card, cardState, userCard);
    }
  }, {
    key: "disableRecordButton",
    get: function get() {
      return !(0, _utils.isPresent)(this.userInputStore.messageInput) && (!this.userInputStore.hasRecording || this.userInputStore.isRecording);
    }

    // MEDIA
  }, {
    key: "pauseMedia",
    value: function pauseMedia() {
      if ((0, _utils.isPresent)(this.userInputStore)) {
        this.userInputStore.pause();
      }
      if (this.canRecordMedia && (0, _utils.isPresent)(this.userInputStore)) {
        this.userInputStore.stopRecording();
      }
    }
  }, {
    key: "resetDeck",
    value: function resetDeck() {
      var _this$currentCard5;
      this.cancelDeckLoad();
      this.onNewDeck();
      this.overlayExpanded = null;
      if (this.deckState) {
        this.deckState.onReset();
      }
      if ((_this$currentCard5 = this.currentCard) !== null && _this$currentCard5 !== void 0 && _this$currentCard5.cardState) {
        this.currentCard.cardState.onReset();
      }
      this.userDeckStore.onReset({
        ids: {
          userDeckId: this.userDeck.id
        }
      }, this.loadDeck.bind(this, {
        id: this.deck.id,
        callback: _lodash.noop
      }));
      this.deckStore.clearShowData();
      this.userDeckStore.clearShowData();
    }
  }, {
    key: "hideDeckArrowBox",
    get: function get() {
      return this.arrowBoxIsHidden || this.cardIsAnimating || this.showLoadingIcon || this.currentCardState.submittedToFeed || (0, _utils.isPresent)(this.userInputStore) && this.userInputStore.inputType === 'text' || (0, _utils.isPresent)(this.messageInput);
    }
  }, {
    key: "showOnboardingTip",
    get: function get() {
      return !this.hideDeckArrowBox && (0, _utils.isPresent)(this.deckArrowBox) && this.deckArrowBox.match('Onboarding');
    }
  }, {
    key: "mediaBlocked",
    get: function get() {
      return this.cardIsAnimating || (0, _utils.isPresent)(this.overlayExpanded) || this.showOnboardingTip;
    }

    // REVIEWS
  }, {
    key: "reviewDeck",
    get: function get() {
      return this.deck.deckType === 'review' || this.routeStore.pathname() && this.routeStore.pathname().match('reviews');
    }

    // MEDIA
  }, {
    key: "canRecordVideo",
    get: function get() {
      return this.userResponseCard && this.canRecordMedia;
    }
  }, {
    key: "deviceCanRecordMedia",
    get: function get() {
      return (this.layout.isNative || this.layout.mediaRecorderSupported) && !this.deviceDeniedAccess;
    }
  }, {
    key: "canRecordMedia",
    get: function get() {
      return this.userIsLoaded && !this.user.blockMediaAccess && this.deviceCanRecordMedia;
    }
  }, {
    key: "showAncillaryCard",
    get: function get() {
      return this.checkpointCard || this.deckSummaryCard;
    }
  }, {
    key: "isLastCard",
    get: function get() {
      return this.currentCard ? this.currentCard.isLastCard : null;
    }

    // FEED
  }, {
    key: "onRetireReview",
    value: function onRetireReview() {
      _overlay_ui["default"].clearOverlays();
      this.cardStore.retire({
        ids: {
          cardId: this.currentCard.id
        }
      }, _lodash.noop);
      this.advanceCard(this.currentCard, this.currentCardState, this.currentUserCard);
    }
  }, {
    key: "updateSpacedRepetitionFields",
    value: function updateSpacedRepetitionFields(card) {
      var retire = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var data = {
        last_score: card.lastScore,
        views_count: card.viewsCount,
        easiness_factor: card.easinessFactor,
        repetition_interval: card.repetitionInterval,
        review_after: card.reviewAfter ? card.reviewAfter.toString : null,
        consecutive_good_scores: card.consecutiveGoodScores,
        had_positive_score: card.hadPositiveScore
      };
      data.retire = retire;
      if (!this.localUserDeck) {
        this.cardStore.update({
          data: data,
          ids: {
            cardId: card.id
          }
        }, _lodash.noop);
      }
    }
  }, {
    key: "onSubmitToFeed",
    value: function onSubmitToFeed() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var xp;
      if ((0, _utils.isPresent)(this.userInputStore) && this.userInputStore.messageInput) {
        xp = 3;
        this.onSubmitMessageToFeed();
      } else if ((0, _utils.isPresent)(this.userInputStore) && this.userInputStore.hasRecording) {
        if (this.userInputStore.mediaType === 'audio') {
          xp = 5;
        } else {
          xp = 7;
        }
        this.onSubmitMediaToFeed();
      }
      if ((0, _utils.isPresent)(this.userInputStore) && this.userInputStore.messageInput || (0, _utils.isPresent)(this.userInputStore) && this.userInputStore.hasRecording) {
        var _this$currentUserCard2;
        if (((_this$currentUserCard2 = this.currentUserCard) === null || _this$currentUserCard2 === void 0 ? void 0 : _this$currentUserCard2.xp) === 0) {
          this.incrementXp(xp);
          this.userDeck.currentUserCard.set('xp', xp);
          this.createXpAnimation({
            type: 'deck',
            namespace: this.userDeck.id,
            id: (0, _utils.createUuid)(),
            xp: xp,
            xpXPos: params.xpXPos
          });
        }
      }
    }
  }, {
    key: "onSubmitMediaToFeed",
    value: function onSubmitMediaToFeed() {
      if (!this.layout.isNative) {
        this.currentCardState.submittingToFeed = true;
        this.feedEntryStore.multipartCreate({
          data: this.userInputStore && this.userInputStore.getFormData(),
          queryStrings: {
            duration: this.userInputStore && this.userInputStore.duration,
            concept_id: this.deck.conceptId,
            deck_id: this.deck.id,
            card_rule_id: this.currentCard.cardRuleId
          }
        }, this.afterCreateFeedEntry.bind(this));
      }
    }
  }, {
    key: "onSubmitMessageToFeed",
    value: function onSubmitMessageToFeed() {
      this.currentCardState.submittingToFeed = true;
      this.feedEntryStore.create({
        data: {
          message: (0, _utils.isPresent)(this.userInputStore) && this.userInputStore.messageInput,
          concept_id: this.deck.conceptId,
          deck_id: this.deck.id,
          card_rule_id: this.currentCard.cardRuleId
        }
      }, this.afterCreateFeedEntry.bind(this));
    }
  }, {
    key: "afterCreateFeedEntry",
    value: function afterCreateFeedEntry(resp) {
      if ((0, _utils.isPresent)(this.userInputStore)) {
        this.userInputStore.setInputType(null);
      }
      if ((0, _utils.isPresent)(this.currentCardState)) {
        this.currentCardState.submittingToFeed = false;
        this.currentCardState.submittedToFeed = true;
      }
      this.lastFeedEntryId = resp.id;
    }

    // CARD NOTICE
  }, {
    key: "setCardNotice",
    value: function setCardNotice(params) {
      clearTimeout(this._timeout);
      this.cardNotice = params;
      if (params.timeout) {
        this._timeout = setTimeout(this.hideCardNotice.bind(this), params.timeout);
      }
    }
  }, {
    key: "hideCardNotice",
    value: function hideCardNotice() {
      clearTimeout(this._timeout);
      this.cardNotice = null;
    }

    // ACTIONS
  }, {
    key: "createXpAnimation",
    value: function createXpAnimation(params) {
      if (!this.user.showCoinAnimation) {
        params.hideCoinAnimation = true;
      }
      if (params.xp > 0 && params.triviaCard) {
        this.soundEffectStore.play('correctChime');
      } else if (params.xp > 0) {
        this.soundEffectStore.play('correct');
      } else {
        this.soundEffectStore.play('failure');
      }
      this.xpState.createXpAnimation(params);
    }
  }, {
    key: "onWordClick",
    value: function onWordClick() {
      this.wordClickCount += 1;
    }
  }, {
    key: "onSoftReset",
    value: function onSoftReset() {
      var _this$currentUserCard3;
      if (this.logger) {
        this.logger.log('onSoftReset called');
      }
      if (this.triviaCard && (0, _lodash.isFunction)((_this$currentUserCard3 = this.currentUserCard) === null || _this$currentUserCard3 === void 0 ? void 0 : _this$currentUserCard3.set)) {
        this.currentUserCard.set('seen', false);
      }
      this.overlayExpanded = null;
      this.onReset();
    }
  }, {
    key: "createUserInputStores",
    value: function createUserInputStores() {
      var _this11 = this;
      this.disposeAllUserInputStores();
      this.userInputStores = {};
      var UserInputStoreClass = this.layout.isNative ? _stores.NativeUserInputStore : _stores.WebUserInputStore;
      (0, _lodash.each)(this.deck.cards, function (card) {
        _this11.userInputStores[card.id] = new UserInputStoreClass({
          parent: _this11,
          cardId: card.id,
          isNative: _this11.layout.isNative
        });
      });
    }
  }, {
    key: "setMobileOnCloseDeckCallback",
    value: function setMobileOnCloseDeckCallback(callback) {
      this.mobileOnCloseDeckCallback = callback;
    }
  }, {
    key: "setNativeLogger",
    value: function setNativeLogger(logger) {
      this.logger = logger;
    }
  }, {
    key: "setNativeKeyboardDismiss",
    value: function setNativeKeyboardDismiss(callback) {
      this.nativeKeyboardDismiss = callback;
    }
  }, {
    key: "setNativeCreateEventHandler",
    value: function setNativeCreateEventHandler(callback) {
      this.nativeCreateEventHandler = callback;
    }
  }, {
    key: "reloadReviewDeck",
    value: function reloadReviewDeck() {
      this.onCloseDeck();
      this.loadDeck({
        id: this.deck.id
      });
    }
  }, {
    key: "onCloseDeck",
    value: function onCloseDeck() {
      _overlay_ui["default"].clearOverlays();
      if ((0, _lodash.isFunction)(this.nativeKeyboardDismiss)) {
        this.nativeKeyboardDismiss();
      }
      clearTimeout(this.checkLoadTimeTimeout);
      if ((0, _utils.isPresent)(this.currentCardState)) {
        this.currentCardState.onReset();
      }
      if ((0, _utils.isPresent)(this.userInputStore)) {
        if (this.userInputStore.playing) {
          this.userInputStore.pause();
        }
      }
      if (this.mobileOnCloseDeckCallback) {
        if (this.logger) {
          this.logger.log('Executing mobileOnCloseDeckCallback');
        }
        this.mobileOnCloseDeckCallback();
      }
      this.disposeDeckResources();
      this.onReset();
      _exercise_ui["default"].reset();
      this.cardIsAnimating = false;
      this.firstCardHasAdvanced = false;
    }
  }, {
    key: "onResetUserInputStore",
    value: function onResetUserInputStore() {
      if ((0, _utils.isPresent)(this.userInputStore)) {
        this.userInputStore.onMediaReset();
      }
    }
  }, {
    key: "onReset",
    value: function onReset() {
      this.arrowBoxIsHidden = false;
      this.textRevealed = false;
      this.showCloseModal = false;
      this.seenConceptDescription = false;
      this.lastFeedEntryId = null;
      this.warning = '';
      this.reviewModalWord = {};
      this.reviewModalConcept = {};
      if ((0, _utils.isPresent)(this.userInputStore) && (0, _lodash.isFunction)(this.userInputStore.reset)) {
        if (this.logger) {
          this.logger.log('Resetting userInputStore');
        }
        this.userInputStore.reset();
      }
      // Don't reset media stores here - they should only be reset when explicitly needed
      // (e.g., when closing the deck or on the last card)
      // This prevents audio/video interruptions during normal card transitions
      this.vocabStuckClicked = false;
      this.sound = null;
      if ((0, _utils.isPresent)(this.currentCardState) && this.currentCardState.onReset) {
        if (this.logger) {
          this.logger.log('Calling currentCardState.onReset()');
        }
        this.currentCardState.onReset();
      }
    }
  }, {
    key: "canOpenDeckVocabCard",
    value: function canOpenDeckVocabCard(card, cardState) {
      var requiresRevealed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if ((0, _utils.isBlank)(card === null || card === void 0 ? void 0 : card.word)) {
        return false;
      }
      if (requiresRevealed && !(cardState !== null && cardState !== void 0 && cardState.revealed)) {
        return false;
      }
      return true;
    }
  }, {
    key: "setDeckScreenFocused",
    value: function setDeckScreenFocused(value) {
      this.deckScreenFocused = value;
      if (!value) {
        this.finishNativeCardTransition();
      }
    }
  }, {
    key: "openDeckVocabCard",
    value: function openDeckVocabCard() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        card = _ref2.card,
        cardState = _ref2.cardState,
        _ref2$requiresReveale = _ref2.requiresRevealed,
        requiresRevealed = _ref2$requiresReveale === void 0 ? false : _ref2$requiresReveale,
        _ref2$trackEvent = _ref2.trackEvent,
        trackEvent = _ref2$trackEvent === void 0 ? true : _ref2$trackEvent,
        _ref2$navigation = _ref2.navigation,
        navigation = _ref2$navigation === void 0 ? null : _ref2$navigation;
      if (!this.canOpenDeckVocabCard(card, cardState, requiresRevealed)) {
        return;
      }
      if (trackEvent) {
        var _this$deck9, _card$cardType3;
        this.createEvent('deck - click vocab icon', {
          language_id: (card === null || card === void 0 ? void 0 : card.languageId) || ((_this$deck9 = this.deck) === null || _this$deck9 === void 0 ? void 0 : _this$deck9.languageId),
          card_type_id: (card === null || card === void 0 || (_card$cardType3 = card.cardType) === null || _card$cardType3 === void 0 ? void 0 : _card$cardType3.id) || (card === null || card === void 0 ? void 0 : card.cardTypeId)
        });
      }
      var activeNavigation = navigation || this.deckNavigation;
      if (this.layout.isNative && activeNavigation !== null && activeNavigation !== void 0 && activeNavigation.navigate) {
        this.designateUiElementAsSeen('vocabCardOnboarding');
        var wordStoreId = this.nativeCreateWordStore ? this.nativeCreateWordStore(card.word) : null;
        var params = {
          wordId: card.word.id
        };
        if (card.synonymAssociationId) {
          params.synonymAssociationId = card.synonymAssociationId;
        }
        if (wordStoreId) {
          params.wordStoreId = wordStoreId;
        }
        activeNavigation.navigate('VocabCard', params);
        return;
      }
      this.gotoVocabCard(card);
    }
  }, {
    key: "gotoVocabCard",
    value: function gotoVocabCard(card) {
      if ((0, _utils.isBlank)(card.word)) {
        return;
      }
      this.designateUiElementAsSeen('vocabCardOnboarding');
      this.overlayExpanded = null;
      var wordStore = new _stores.WordStore.constructor();
      var wordSentenceStore = new _stores.WordSentenceStore.constructor();
      var conjugatedVerbStringStore = new _stores.ConjugatedVerbStringStore.constructor();
      wordStore.setShowData(card.word);
      _overlay_ui["default"].addOverlay('vocabCard', {
        card: card,
        wordStore: wordStore,
        wordSentenceStore: wordSentenceStore,
        conjugatedVerbStringStore: conjugatedVerbStringStore,
        allowDuplicates: true,
        useOverlayNavigation: true
      });
    }
  }, {
    key: "gotoWordVocabCard",
    value: function gotoWordVocabCard(word) {
      var wordStore = new _stores.WordStore.constructor();
      var wordSentenceStore = new _stores.WordSentenceStore.constructor();
      var conjugatedVerbStringStore = new _stores.ConjugatedVerbStringStore.constructor();
      wordStore.setShowData(word);
      _overlay_ui["default"].addOverlay('vocabCard', {
        word: word,
        wordStore: wordStore,
        wordSentenceStore: wordSentenceStore,
        conjugatedVerbStringStore: conjugatedVerbStringStore,
        allowDuplicates: true,
        useOverlayNavigation: true
      });
    }
  }, {
    key: "gotoTriviaResults",
    value: function gotoTriviaResults(card) {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('triviaResults', {
        card: card
      });
    }
  }, {
    key: "gotoShortcuts",
    value: function gotoShortcuts() {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('shortcuts');
    }
  }, {
    key: "gotoCardComments",
    value: function gotoCardComments(card) {
      this.designateUiElementAsSeen('commentOnboarding');
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('cardComments', {
        card: card
      });
      this.createEvent('deck - view comments', {
        languageId: this.deck.languageId,
        deckId: this.deck.id,
        cardId: card.id
      });
    }
  }, {
    key: "gotoGrammarTip",
    value: function gotoGrammarTip(card) {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('grammarTip', {
        card: card
      });
      this.designateUiElementAsSeen('caseConcept');
      this.createEvent('deck - open grammar tip', {
        languageId: this.deck.languageId,
        deckId: this.deck.id,
        cardId: card.id
      });
    }
  }, {
    key: "gotoCardNote",
    value: function gotoCardNote(card) {
      this.designateUiElementAsSeen('noteOnboarding');
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('cardNote', {
        card: card
      });
    }
  }, {
    key: "gotoReviewDetails",
    value: function gotoReviewDetails(card) {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('reviewDetails', {
        card: card
      });
    }
  }, {
    key: "gotoConjugationTable",
    value: function gotoConjugationTable(word) {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('conjugationTable', {
        word: word
      });
    }
  }, {
    key: "gotoDeckSettings",
    value: function gotoDeckSettings() {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('deckSettings');
    }
  }, {
    key: "gotoReportBug",
    value: function gotoReportBug() {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('reportBug');
    }
  }, {
    key: "gotoDeckGrammar",
    value: function gotoDeckGrammar() {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('deckGrammar');
    }
  }, {
    key: "closeDeckGrammar",
    value: function closeDeckGrammar() {
      _overlay_ui["default"].removeOverlay('conjugationTable');
    }
  }, {
    key: "gotoConceptDescription",
    value: function gotoConceptDescription() {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('conceptDescription');
    }

    // Deprecated - kept for backward compatibility
  }, {
    key: "gotoTenseDescription",
    value: function gotoTenseDescription() {
      this.gotoConceptDescription();
    }

    // Deprecated - kept for backward compatibility
  }, {
    key: "gotoCaseDescription",
    value: function gotoCaseDescription() {
      this.gotoConceptDescription();
    }
  }, {
    key: "gotoMediaBlocked",
    value: function gotoMediaBlocked() {
      _overlay_ui["default"].addOverlay('mediaBlocked');
    }
  }, {
    key: "skipToEnd",
    value: function skipToEnd() {
      var _this12 = this;
      this.finishNativeCardTransition();
      _overlay_ui["default"].clearOverlays();
      if ((0, _utils.isBlank)(this.userDeck)) {
        return;
      }
      (0, _lodash.each)(this.userDeck.userCards.filter(function (item) {
        return item.cardId !== _this12.deck.lastCard.id;
      }), function (userCard) {
        userCard.seen = true;
        userCard.skipped = true;
        userCard.active = false;
      });
      var card = this.deck.cards.find(function (item) {
        return item.cardType && item.cardType.slug === 'deck_summary';
      });
      var userCard = this.userDeck.userCards.find(function (item) {
        return item.cardId === card.id;
      });
      this.animationCards = [{
        id: (0, _utils.createUuid)(),
        card: card,
        userCard: userCard,
        cardState: card.cardState,
        position: 0,
        advanceCard: false,
        animateCard: false
      }, {
        id: (0, _utils.createUuid)(),
        card: this.deck.lastCard,
        userCard: this.userDeck.lastUserCard,
        cardState: this.deck.lastCard.cardState,
        position: 1,
        advanceCard: false,
        animateCard: false
      }];
      this.gotoCard(card.id);
    }
  }, {
    key: "gotoCard",
    value: function gotoCard(id) {
      this.onReset();
      this.userDeck.gotoCard(id);
      this.userDeckStore.update({
        ids: {
          userDeckId: this.userDeck.id
        },
        data: {
          current_card_id: id
        }
      }, _lodash.noop);
    }
  }, {
    key: "jumpToCard",
    value: function jumpToCard(id) {
      var _this$currentCard6;
      if (!id || !this.hasDeck || !this.hasUserDeck) {
        return;
      }
      var card = this.deck.cards.find(function (item) {
        return item.id === id;
      });
      var userCard = this.userDeck.userCards.find(function (item) {
        return item.cardId === id;
      });
      if (!card || !userCard || ((_this$currentCard6 = this.currentCard) === null || _this$currentCard6 === void 0 ? void 0 : _this$currentCard6.id) === id) {
        return;
      }
      this.onSoftReset();
      this.setSkipCardAnimation(true);
      this.gotoCard(id);
      this.initializeCardAnimation();
    }
  }, {
    key: "gotoCardList",
    value: function gotoCardList() {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('goToCard');
    }
  }, {
    key: "showExerciseAnswer",
    value: function showExerciseAnswer(card, cardState, userCard) {
      var _this13 = this;
      this.reveal(card, cardState);
      _exercise_ui["default"].revealExerciseAnswers({
        skipAudio: true,
        correctCallback: function correctCallback() {
          return _this13.onCorrectAnswer(card, cardState, userCard, {
            xp: 1,
            xpSlug: 'exercise'
          });
        },
        incorrectCallback: function incorrectCallback() {
          return _this13.onIncorrectAnswer(card, cardState, userCard);
        }
      });
    }
  }, {
    key: "onCorrectAnswer",
    value: function onCorrectAnswer(card, cardState, userCard) {
      var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      this.blurInputFocus();
      var xp = params.xp || 2;
      if (xp && !params.xpSlug) {
        params.xpSlug = 'exercise';
      }
      var score = params.score || 2;
      var points = params.points || 0;
      var firstAnswerCorrect = !userCard.seen;
      userCard.set('correct', true);
      userCard.set('firstAnswerCorrect', firstAnswerCorrect);
      if (!this.reviewDeck) {
        userCard.set('score', score);
        userCard.set('active', false);
        if (userCard.xp === 0) {
          this.incrementXp(xp);
          userCard.set('xp', xp);
        }
        userCard.set('currentCorrect', true);
        if (!this.localUserDeck) {
          this.userCardStore.update({
            ids: {
              userCardId: userCard.id
            },
            data: {
              score: score,
              active: false,
              points: points,
              correct: true,
              first_answer_correct: firstAnswerCorrect,
              points_submitted: true,
              seconds_elapsed: params.secondsElapsed,
              xp: xp,
              multiple_choice_option_id: params.multipleChoiceOptionId,
              xp_slug: params.xpSlug
            }
          }, _lodash.noop);
        }
        this.createXpAnimation({
          xp: xp,
          id: (0, _utils.createUuid)(),
          triviaCard: card.triviaCard,
          namespace: this.userDeck.id,
          xpXPos: 200
        });
      }
    }
  }, {
    key: "onIncorrectAnswer",
    value: function onIncorrectAnswer(card, cardState, userCard) {
      var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      this.blurInputFocus();
      userCard.set('currentIncorrect', true);
      userCard.set('firstAnswerCorrect', false);
      if (this.reviewDeck && card.wordOptionsCard) {
        this.soundEffectStore.play('failure');
      }
      if (!this.reviewDeck) {
        userCard.set('score', 0);
        userCard.set('points', 0);
        userCard.set('pointsSubmitted', true);
        if (!this.localUserDeck) {
          this.userCardStore.update({
            ids: {
              userCardId: userCard.id
            },
            data: {
              score: 0,
              points: 0,
              correct: false,
              points_submitted: true,
              multiple_choice_option_id: params.multipleChoiceOptionId,
              seconds_elapsed: params.secondsElapsed
            }
          }, _lodash.noop);
        }
        this.createXpAnimation({
          xp: 0,
          id: (0, _utils.createUuid)(),
          triviaCard: card.triviaCard,
          namespace: this.userDeck.id,
          xpXPos: 200
        });
      }
    }
  }, {
    key: "blurInputFocus",
    value: function blurInputFocus() {
      if (!this.layout.isNative) {
        (0, _lodash.each)(document.getElementsByTagName('input'), function (el) {
          el.blur();
        });
      }
    }
  }, {
    key: "incrementXp",
    value: function incrementXp(xp) {
      if (xp && xp > 0) {
        if (!(0, _utils.isPresent)(this.user) || !(0, _lodash.isFunction)(this.user.incrementXp) || !(0, _utils.isPresent)(this.targetLanguage) || !(0, _lodash.isFunction)(this.targetLanguage.incrementXp)) {
          return;
        }
        var beforeUpdateXp = this.user.currentDayXp;
        var beforeUpdateLevel = this.targetLanguage.xpLevel;
        this.user.incrementXp(xp);
        this.targetLanguage.incrementXp(xp);
        var afterUpdateLevel = this.targetLanguage.xpLevel;
        var streakMet = beforeUpdateXp < this.user.dailyXpGoal && this.user.currentDayXp >= this.user.dailyXpGoal;
        if (streakMet) {
          this.user.set('currentStreakCount', this.user.currentStreakCount + 1);
          this.setCardNotice({
            timeout: 7500,
            text: "".concat(this.user.currentStreakCount, " Day Streak!"),
            background: '#FFF',
            color: '#333',
            border: "4px solid ".concat(_constants.Theme.green),
            icon: 'streak',
            chime: true
          });
        } else if ((0, _utils.isPresent)(this.deck.xpBreakdownToday)) {
          this.deck.xpBreakdownToday.set('count', this.deck.xpBreakdownToday.count + 1);
          if (this.reviewDeck && this.deck.useDailyGoal && this.deck.reviewedToday === this.deck.dailyGoal) {
            this.setCardNotice({
              timeout: 7500,
              text: 'Daily Goal Reached for this Deck!',
              background: '#FFF',
              color: '#333',
              border: "4px solid ".concat(_constants.Theme.green),
              icon: 'celebration',
              chime: true
            });
          }
        }
        var streakExtendGoalMet = beforeUpdateXp < this.user.streakExtendGoal && this.user.currentDayXp >= this.user.streakExtendGoal;
        var streakExtendNoticeGoal = Math.floor(this.user.streakExtendGoal * 0.75);
        if (streakExtendGoalMet && this.user.streakExtensionIsAllowed) {
          this.setCardNotice({
            timeout: 10000,
            text: "Congrats on reaching ".concat(this.user.streakExtendGoal, "XP!"),
            subText: 'To reward you, we\'ve extended your streak.',
            background: '#FFF',
            color: '#333',
            border: "4px solid ".concat(_constants.Theme.green),
            icon: 'streak',
            chime: true
          });
        } else if (beforeUpdateXp < streakExtendNoticeGoal && this.user.currentDayXp >= streakExtendNoticeGoal && this.user.streakExtensionIsAllowed) {
          this.setCardNotice({
            timeout: 15000,
            text: "You\u2019ve reached ".concat(streakExtendNoticeGoal, "XP, well done!"),
            subText: "Did you know that at ".concat(this.user.streakExtendGoal, "XP we will reward you with a streak extension?"),
            background: '#FFF',
            color: '#333'
          });
        }
        if (beforeUpdateLevel !== afterUpdateLevel) {
          this.setCardNotice({
            timeout: 7500,
            text: "You are now Level ".concat(this.targetLanguage.xpLevel, "!"),
            background: '#FFF',
            color: '#333',
            border: "4px solid ".concat(_constants.Theme.green),
            icon: 'celebration',
            chime: true
          });
        }
      }
    }
  }, {
    key: "advanceCard",
    value: function advanceCard(card, cardState, userCard) {
      var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      _overlay_ui["default"].clearOverlays();
      userCard.set('seen', true);
      if (this.logger) {
        this.logger.log('advanceCard called for card:', card === null || card === void 0 ? void 0 : card.id, 'isLastCard:', this.isLastCard);
      }
      var allowAdvancement = params.forceAdvancement || params.score === _constants.Constants.GOOD_SCORE || params.score === _constants.Constants.EASY_SCORE || !this.blockLastLearningCardAdvancement;
      this.hideCardNotice();
      if (allowAdvancement) {
        var _card$cardRule, _card$cardRule2;
        if ((0, _utils.isPresent)(this.userInputStores[card.id])) {
          if (this.logger) {
            this.logger.log('Clearing userInputStore for card before advancement:', card.id);
          }
          this.userInputStores[card.id].onReset();
        }
        var xpSlug;
        var score = params.score;
        if ((0, _utils.isPresent)(params.xp) && userCard.xp === 0 && (!card.exerciseCard || this.reviewDeck)) {
          this.createXpAnimation({
            type: 'deck',
            namespace: this.userDeck.id,
            id: (0, _utils.createUuid)(),
            xp: params.xp,
            xpXPos: params.xpXPos
          });
          xpSlug = this.getXpSlug(params);
        }
        if (!score && !this.reviewDeck && ((_card$cardRule = card.cardRule) !== null && _card$cardRule !== void 0 && _card$cardRule.cycleCardsUntilCorrect || card.triviaCard)) {
          score = userCard.correct ? _constants.Constants.EASY_SCORE : _constants.Constants.BAD_SCORE;
        }
        cardState.submittedToFeed = false;
        this.wordClickCount = 0;
        this.cardSeenCount += 1;
        if ((0, _utils.isPresent)(params.xp)) {
          this.incrementXp(params.xp);
        }
        var data = {
          xp: params.xp,
          xp_slug: params.overrideXpSlug || xpSlug
        };
        if ((0, _utils.isPresent)(score)) {
          data.score = score;
          userCard.set('score', score);
          if (this.reviewDeck) {
            var _this$user0;
            if (score !== _constants.Constants.BAD_SCORE && card.reviewAfter && card.reviewAfter.dateObj && card.reviewAfter.dateObj < new Date()) {
              this.user.set('pastDueReviewCardsCount', this.user.pastDueReviewCardsCount - 1);
            }
            card.processScore(score, {
              reviewsDueAtBeginningOfDay: (_this$user0 = this.user) === null || _this$user0 === void 0 ? void 0 : _this$user0.reviewsDueAtBeginningOfDay
            });
            this.updateSpacedRepetitionFields(card, params.retire);
          }
        }
        if (!this.localUserDeck) {
          this.userCardStore.update({
            ids: {
              userCardId: userCard.id
            },
            data: data
          }, _lodash.noop);
        }
        var active = 'active' in params ? params.active : [_constants.Constants.BAD_SCORE, 0].includes(score) && (((_card$cardRule2 = card.cardRule) === null || _card$cardRule2 === void 0 ? void 0 : _card$cardRule2.cycleCardsUntilCorrect) || this.reviewDeck);
        userCard.set('localUpdatedAt', +new Date());
        userCard.set('active', active);
        userCard.set('skipped', false);
        if (userCard.xp === 0) {
          userCard.set('xp', params.xp);
        }
        if (this.userDeck && this.userDeck.setProgressCurrent) {
          this.userDeck.setProgressCurrent(this.userDeck.progressCurrent + 1);
        }
        this.setCurrentCard();
        this.addNextCardToAnimationQueue();
        if (this.isSecondToLastCard) {
          this.animationQueue.push({
            name: 'deckCompleted',
            deckId: this.deck.id
          });
        }
      } else {
        this.onResetUserInputStore();
        if (this.reviewDeck && params.score === _constants.Constants.BAD_SCORE) {
          var _this$user1;
          userCard.set('score', params.score);
          card.processScore(params.score, {
            reviewsDueAtBeginningOfDay: (_this$user1 = this.user) === null || _this$user1 === void 0 ? void 0 : _this$user1.reviewsDueAtBeginningOfDay
          });
          this.updateSpacedRepetitionFields(card);
        }
      }
      this.onReset();
      if (this.exercise) {
        this.exercise.state.reset();
      }
    }
  }, {
    key: "exercise",
    get: function get() {
      if ((0, _utils.isBlank)(this.currentCard)) {
        return;
      }
      return _exercise_ui["default"].exercises[this.currentCard.id];
    }
  }, {
    key: "getXpSlug",
    value: function getXpSlug(params) {
      var xpSlug;
      if (this.reviewDeck) {
        xpSlug = 'card-review-deck';
      } else if (params.score === 0) {
        xpSlug = 'card-add-to-review';
      } else {
        xpSlug = 'card';
      }
      return xpSlug;
    }
  }, {
    key: "blockLastLearningCardAdvancement",
    get: function get() {
      var _this$currentCard$car;
      if ((0, _utils.isBlank)(this.currentCard)) {
        return;
      }
      var remainingCards = this.reviewDeck ? this.userDeck.numberActiveLearningCards : this.userDeck.numberActiveLearningCardsWithCardType;
      return ((_this$currentCard$car = this.currentCard.cardRule) === null || _this$currentCard$car === void 0 ? void 0 : _this$currentCard$car.cycleCardsUntilCorrect) && this.currentUserCard.active && remainingCards === 1;
    }
  }, {
    key: "nextCurrentCard",
    get: function get() {
      var _this14 = this;
      return this.nextCurrentCardId && this.hasDeck && this.deck.cards && this.deck.cards.find(function (item) {
        return item.id === _this14.nextCurrentCardId;
      });
    }
  }, {
    key: "nextCurrentCardId",
    get: function get() {
      if (!this.userDeck) {
        return;
      }
      return this.reviewDeck ? this.userDeck.cardIdForNextActiveUserCardWithWrapping : this.userDeck.cardIdForNextActiveUserCardWithWrappingByCardType;
    }
  }, {
    key: "gotoPreviousCard",
    value: function gotoPreviousCard() {
      var _this15 = this;
      this.finishNativeCardTransition();
      if (!this.isFirstCard && (0, _utils.isPresent)(this.userDeck)) {
        this.onReset();
        this.overlayExpanded = null;
        if (!this.userDeck.currentUserCardIsFirstInDeck && this.userDeck.previousUserCard) {
          var nextCurrentCard = this.currentCard;
          var nextUserCard = this.currentUserCard;
          _stores.UserDeckStore.update({
            ids: {
              userDeckId: this.userDeck.id
            },
            data: {
              current_card_id: this.userDeck.previousUserCard.cardId
            }
          }, _lodash.noop);
          if (!nextUserCard.active) {
            nextUserCard.set('active', true);
            this.userCardStore.update({
              ids: {
                userCardId: nextUserCard.id
              },
              data: {
                active: true
              }
            }, _lodash.noop);
          }
          this.userDeck.previousUserCard.set('active', true);
          this.userCardStore.update({
            ids: {
              userCardId: this.userDeck.previousUserCard.id
            },
            data: {
              active: true
            }
          }, _lodash.noop);
          this.userDeck.set('progressCurrent', this.userDeck.progressCurrent - 1);
          this.userDeck.set('currentCardId', this.userDeck.previousUserCard.cardId);
          var currentCard = this.deck.cards.find(function (item) {
            return item.id === _this15.userDeck.currentCardId;
          });
          var userCard = this.userDeck.userCards.find(function (item) {
            return item.cardId === currentCard.id;
          });
          this.animationCards = [{
            id: (0, _utils.createUuid)(),
            card: currentCard,
            userCard: userCard,
            cardState: currentCard.cardState,
            position: 0,
            advanceCard: false,
            animateCard: false
          }, {
            id: (0, _utils.createUuid)(),
            card: nextCurrentCard,
            userCard: nextUserCard,
            cardState: nextCurrentCard.cardState,
            position: 1,
            advanceCard: false,
            animateCard: false
          }];
        }
        this.onReset();
      }
    }
  }, {
    key: "setCurrentCard",
    value: function setCurrentCard() {
      if (this.nextCurrentCardId && !this.blockLastLearningCardAdvancement) {
        var _this$currentUserCard4;
        _stores.UserDeckStore.update({
          ids: {
            userDeckId: this.userDeck.id
          },
          data: {
            current_card_id: this.nextCurrentCardId
          }
        }, _lodash.noop);
        this.userDeck.set('currentCardId', this.nextCurrentCardId);
        if ((0, _lodash.isFunction)((_this$currentUserCard4 = this.currentUserCard) === null || _this$currentUserCard4 === void 0 ? void 0 : _this$currentUserCard4.set) && !this.currentUserCard.active) {
          this.currentUserCard.set('active', true);
        }
      }
      // Don't call onReset here - it's already called in advanceCard
      // This prevents duplicate resets during card transitions
      if (this.currentCard) {
        if (_exercise_ui["default"].exercises[this.currentCard.id]) {
          _exercise_ui["default"].exercises[this.currentCard.id].state.reset();
        }
        if ((0, _utils.isPresent)(this.currentCardState) && this.currentCardState.onReset) {
          this.currentCardState.onReset();
        }
      }
    }
  }, {
    key: "removeFromAnimationQueue",
    value: function removeFromAnimationQueue(key, value) {
      this.animationQueue = this.animationQueue.filter(function (item) {
        return item[key] != value;
      });
    }
  }, {
    key: "setDeckNavigationCompleted",
    value: function setDeckNavigationCompleted(value) {
      this.deckNavigationCompleted = value;
    }
  }, {
    key: "onNewDeck",
    value: function onNewDeck() {
      this.nativeCardTransition = null;
      this.clearCardAnimationTimeouts();
      this.reviewSessionReviewedBaseline = null;
      this.vocabStuckClicked = false;
      this.cardSeenCount = 0;
      this.skipCardAnimation = false;
      this.cardIsAnimating = false;
      this.firstCardHasAdvanced = false;
      this.animationCards = [];
      this.enrichedTranslations = {};
      this.deckNavigationCompleted = false;
      this.suppressCardSwipeSpring = false;
      this.cardAnimationRecoveryRevision = 0;
      this.cardAnimationNativeMountId = 0;
    }
  }, {
    key: "closeFeedInfo",
    value: function closeFeedInfo() {
      this.currentCardState.closeFeedEntry();
    }
  }, {
    key: "initializeCardAnimation",
    value: function initializeCardAnimation() {
      var _this16 = this;
      this.nativeCardTransition = null;
      this.clearCardAnimationTimeouts();
      this.animationCards = [];
      this.setCardIsAnimating(false);
      if (this.layout.isNative) {
        if (this.currentCard) {
          var _this$currentCard$car2;
          (_this$currentCard$car2 = this.currentCard.cardState) === null || _this$currentCard$car2 === void 0 || _this$currentCard$car2.resetWithinCard();
          this.animationCards.push({
            id: (0, _utils.createUuid)(),
            card: this.currentCard,
            userCard: this.currentUserCard,
            cardState: this.currentCard.cardState,
            position: 0,
            animateCard: false
          });
        }
        if (this.nextCurrentCardId && this.currentCard && this.currentCard.id !== this.nextCurrentCardId) {
          var nextUserCard = this.userDeck.userCards.find(function (item) {
            return item.cardId === _this16.nextCurrentCardId;
          });
          this.addCardToAnimationQueue(this.nextCurrentCard, nextUserCard);
        }
        this.setSkipCardAnimation(false);
        return;
      }
      this.addCardToAnimationQueue(this.currentCard, this.currentUserCard);
      this.addNextCardToAnimationQueue();
    }
  }, {
    key: "addNextCardToAnimationQueue",
    value: function addNextCardToAnimationQueue() {
      var _this17 = this;
      if (this.layout.isNative) {
        this.startNativeCardTransition();
        this.setSkipCardAnimation(false);
        return;
      }
      this.setCardIsAnimating(true);
      if (this.nextCurrentCardId && this.currentCard && this.currentCard.id !== this.nextCurrentCardId) {
        var nextUserCard = this.userDeck.userCards.find(function (item) {
          return item.cardId === _this17.nextCurrentCardId;
        });
        this.addCardToAnimationQueue(this.nextCurrentCard, nextUserCard);
      }
      this.advanceCards();
    }

    // Commit the destination layout before animating. Existing queue entries keep
    // their keys, so the incoming card and its media survive the transition.
  }, {
    key: "startNativeCardTransition",
    value: function startNativeCardTransition() {
      var _this$currentCard7,
        _this18 = this,
        _this$userDeck8,
        _this$nativeCardTrans;
      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.showCardAnimation;
      if (!this.layout.isNative || !((_this$currentCard7 = this.currentCard) !== null && _this$currentCard7 !== void 0 && _this$currentCard7.id)) {
        return;
      }
      this.finishNativeCardTransition();
      this.clearCardAnimationTimeouts();
      var outgoing = this.animationCards.find(function (item) {
        return item.position === 0;
      });
      var entryFor = function entryFor(card, userCard) {
        var _card$cardState5;
        var excluded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        if (!(card !== null && card !== void 0 && card.id)) {
          return null;
        }
        var existing = _this18.animationCards.find(function (item) {
          var _item$card;
          return ((_item$card = item.card) === null || _item$card === void 0 ? void 0 : _item$card.id) === card.id && !excluded.includes(item);
        });
        if (existing) {
          return existing;
        }
        (_card$cardState5 = card.cardState) === null || _card$cardState5 === void 0 || _card$cardState5.resetWithinCard();
        return {
          id: (0, _utils.createUuid)(),
          card: card,
          userCard: userCard,
          cardState: card.cardState,
          animateCard: false
        };
      };
      var incoming = entryFor(this.currentCard, this.currentUserCard);
      if (!incoming) {
        return;
      }
      var nextUserCard = (_this$userDeck8 = this.userDeck) === null || _this$userDeck8 === void 0 ? void 0 : _this$userDeck8.userCards.find(function (item) {
        return item.cardId === _this18.nextCurrentCardId;
      });
      var next = this.nextCurrentCardId !== this.currentCard.id ? entryFor(this.nextCurrentCard, nextUserCard, [outgoing, incoming]) : null;
      var sliding = Boolean(animate && outgoing && outgoing !== incoming && this.deckScreenFocused);
      var cards = [];
      if (outgoing && outgoing !== incoming) {
        outgoing.position = -1;
        cards.push(outgoing);
      }
      incoming.position = 0;
      cards.push(incoming);
      if (next) {
        next.position = 1;
        cards.push(next);
      }
      cards.forEach(function (item) {
        item.animateCard = sliding;
      });
      this.animationCards = cards;
      this.nativeCardTransition = sliding ? {
        id: (0, _utils.createUuid)(),
        cardId: incoming.card.id,
        width: this.layout.deckWidth
      } : null;
      this.setCardIsAnimating(sliding);
      if (!sliding) {
        this.afterCardAdvancement();
      }
      this.logCardAnimation('Committed native card transition', {
        transitionId: (_this$nativeCardTrans = this.nativeCardTransition) === null || _this$nativeCardTrans === void 0 ? void 0 : _this$nativeCardTrans.id
      });
    }
  }, {
    key: "finishNativeCardTransition",
    value: function finishNativeCardTransition() {
      var _this$nativeCardTrans2;
      var transitionId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_this$nativeCardTrans2 = this.nativeCardTransition) === null || _this$nativeCardTrans2 === void 0 ? void 0 : _this$nativeCardTrans2.id;
      var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'interrupted';
      if (!this.layout.isNative || !this.nativeCardTransition || this.nativeCardTransition.id !== transitionId) {
        return false;
      }
      this.nativeCardTransition = null;
      this.animationCards.forEach(function (item) {
        item.animateCard = false;
      });
      this.setCardIsAnimating(false);
      this.afterCardAdvancement();
      this.logCardAnimation('Finished native card transition', {
        transitionId: transitionId,
        reason: reason
      });
      return true;
    }
  }, {
    key: "cardAnimationLogData",
    value: function cardAnimationLogData() {
      var _this$currentCard8, _this$nativeCardTrans3;
      return {
        currentCardId: (_this$currentCard8 = this.currentCard) === null || _this$currentCard8 === void 0 ? void 0 : _this$currentCard8.id,
        cardIsAnimating: this.cardIsAnimating,
        nativeTransitionId: (_this$nativeCardTrans3 = this.nativeCardTransition) === null || _this$nativeCardTrans3 === void 0 ? void 0 : _this$nativeCardTrans3.id,
        suppressCardSwipeSpring: this.suppressCardSwipeSpring,
        recoveryRevision: this.cardAnimationRecoveryRevision,
        nativeMountId: this.cardAnimationNativeMountId,
        deckScreenFocused: this.deckScreenFocused,
        startTimeout: Boolean(this.cardAnimationStartTimeout),
        removeTimeout: Boolean(this.cardAnimationRemoveTimeout),
        safetyTimeout: Boolean(this.cardAnimationSafetyTimeout),
        foregroundResyncTimeout: Boolean(this.cardAnimationForegroundResyncTimeout),
        animationCards: this.animationCards.map(function (item) {
          var _item$card2;
          return {
            cardId: (_item$card2 = item.card) === null || _item$card2 === void 0 ? void 0 : _item$card2.id,
            position: item.position,
            animateCard: Boolean(item.animateCard)
          };
        })
      };
    }
  }, {
    key: "logCardAnimation",
    value: function logCardAnimation(message, extra) {
      if (!this.logger) {
        return;
      }
      this.logger.log(message, extra ? _objectSpread(_objectSpread({}, this.cardAnimationLogData()), extra) : this.cardAnimationLogData());
    }
  }, {
    key: "clearCardAnimationTimeouts",
    value: function clearCardAnimationTimeouts() {
      if (this.cardAnimationStartTimeout) {
        clearTimeout(this.cardAnimationStartTimeout);
        this.cardAnimationStartTimeout = null;
      }
      if (this.cardAnimationRemoveTimeout) {
        clearTimeout(this.cardAnimationRemoveTimeout);
        this.cardAnimationRemoveTimeout = null;
      }
      if (this.cardAnimationSafetyTimeout) {
        clearTimeout(this.cardAnimationSafetyTimeout);
        this.cardAnimationSafetyTimeout = null;
      }
    }
  }, {
    key: "ensureCurrentAnimationCardIsVisible",
    value: function ensureCurrentAnimationCardIsVisible() {
      var _this$currentCard9,
        _this19 = this;
      if (!this.layout.isNative || !((_this$currentCard9 = this.currentCard) !== null && _this$currentCard9 !== void 0 && _this$currentCard9.id)) {
        return false;
      }
      var current = this.animationCards.find(function (item) {
        var _item$card3;
        return ((_item$card3 = item.card) === null || _item$card3 === void 0 ? void 0 : _item$card3.id) === _this19.currentCard.id;
      });
      if ((current === null || current === void 0 ? void 0 : current.position) === 0) {
        return false;
      }
      this.startNativeCardTransition(false);
      return true;
    }
  }, {
    key: "stabilizeCardAnimationPositions",
    value: function stabilizeCardAnimationPositions() {
      var finished = this.finishNativeCardTransition();
      var placed = this.ensureCurrentAnimationCardIsVisible();
      return finished || placed;
    }
  }, {
    key: "pauseCardAnimationForBackground",
    value: function pauseCardAnimationForBackground() {
      return this.stabilizeCardAnimationPositions();
    }
  }, {
    key: "addCardToAnimationQueue",
    value: function addCardToAnimationQueue(card, userCard) {
      var _card$cardState6;
      if ((0, _utils.isBlank)(card)) {
        return;
      }
      var position = (0, _utils.isBlank)(this.animationCards) ? 1 : (0, _lodash.last)(this.animationCards).position + 1;
      card === null || card === void 0 || (_card$cardState6 = card.cardState) === null || _card$cardState6 === void 0 || _card$cardState6.resetWithinCard();
      this.animationCards.push({
        id: (0, _utils.createUuid)(),
        card: card,
        userCard: userCard,
        cardState: card.cardState,
        position: position,
        animateCard: false
      });
    }
  }, {
    key: "decrementCardAnimationPositions",
    value: function decrementCardAnimationPositions() {
      (0, _lodash.each)(this.animationCards, function (card) {
        card.position -= 1;
      });
    }
  }, {
    key: "showCardAnimation",
    get: function get() {
      return this.user.showCardAnimation && !this.skipCardAnimation;
    }
  }, {
    key: "advanceCards",
    value: function advanceCards() {
      var _this20 = this;
      if (this.layout.isNative) {
        this.startNativeCardTransition();
        this.setSkipCardAnimation(false);
        return;
      }
      if (this.showCardAnimation) {
        var delayMs = _constants.Constants.DELAY_BEFORE_INITIATING_CARD_ANIMATION;
        if (this.cardAnimationStartTimeout) {
          clearTimeout(this.cardAnimationStartTimeout);
        }
        this.cardAnimationStartTimeout = setTimeout(function () {
          _this20.cardAnimationStartTimeout = null;
          _this20.startCardAnimation();
        }, delayMs);
      } else {
        this.decrementCardAnimationPositions();
        this.afterCardAdvancement();
        this.set('firstCardHasAdvanced', true);
        this.setCardIsAnimating(false);
      }
      this.setSkipCardAnimation(false);
    }
  }, {
    key: "startCardAnimation",
    value: function startCardAnimation() {
      var _this21 = this;
      if (this.layout.isNative) {
        return this.startNativeCardTransition();
      }
      this.suppressCardSwipeSpring = false;
      this.setCardIsAnimating(true);
      (0, _lodash.each)(this.animationCards, function (card) {
        card.animateCard = true;
      });
      this.logCardAnimation('Started card animation');
      if (this.cardAnimationRemoveTimeout) {
        clearTimeout(this.cardAnimationRemoveTimeout);
      }
      this.cardAnimationRemoveTimeout = setTimeout(function () {
        _this21.cardAnimationRemoveTimeout = null;
        _this21.removeCardAnimation();
      }, _constants.Constants.DELAY_BEFORE_REMOVING_CARD_AFTER_ANIMATION);
    }
  }, {
    key: "removeCardAnimation",
    value: function removeCardAnimation() {
      if (this.layout.isNative) {
        return this.finishNativeCardTransition();
      }
      if (this.cardAnimationRemoveTimeout) {
        clearTimeout(this.cardAnimationRemoveTimeout);
        this.cardAnimationRemoveTimeout = null;
      }
      var hadAnimateCard = this.animationCards.some(function (card) {
        return card.animateCard;
      });
      // Already finalized — do not decrement positions again.
      if (!hadAnimateCard && !this.cardIsAnimating) {
        this.logCardAnimation('Skipped remove card animation', {
          reason: 'already-finalized'
        });
        return;
      }
      if (hadAnimateCard) {
        (0, _lodash.each)(this.animationCards, function (card) {
          card.animateCard = false;
          card.position -= 1;
        });
      }
      this.setCardIsAnimating(false);
      this.logCardAnimation('Removed card animation', {
        hadAnimateCard: hadAnimateCard
      });
      return this.afterCardAdvancement();
    }
  }, {
    key: "resumeCardSwipeSpring",
    value: function resumeCardSwipeSpring() {
      this.suppressCardSwipeSpring = false;
    }
  }, {
    key: "recoverCardAnimationAfterForeground",
    value: function recoverCardAnimationAfterForeground() {
      return this.stabilizeCardAnimationPositions();
    }
  }, {
    key: "afterCardAdvancement",
    value: function afterCardAdvancement() {
      var _this22 = this;
      var cardsToRemove = this.animationCards.filter(function (item) {
        return item.position < 0;
      });
      var cleanupPromises = [];
      cardsToRemove.forEach(function (animationCard) {
        var cardId = animationCard.card.id;
        var userInputStore = _this22.userInputStores[cardId];
        if (userInputStore && userInputStore.cleanupOffscreen) {
          cleanupPromises.push(userInputStore.cleanupOffscreen());
        }
      });
      this.animationCards = this.animationCards.filter(function (item) {
        return item.position >= 0;
      });
      return Promise.all(cleanupPromises);
    }
  }, {
    key: "enrichWord",
    value: function enrichWord(card) {
      var forceEnrichment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!forceEnrichment && card.isEnriched || (0, _utils.isBlank)(card.word)) {
        return;
      }
      if (!forceEnrichment && this.enrichedTranslations[card.word.id]) {
        card.setWord(this.enrichedTranslations[card.word.id]);
      } else {
        this.wordStore.getShow({
          ids: {
            wordId: card.word.id
          }
        }, this.afterGetEnrichedWord.bind(this, card));
      }
    }
  }, {
    key: "enrichSentence",
    value: function enrichSentence(card) {
      var _card$cardType4, _card$cardType5;
      var forceEnrichment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isTriviaCard = ((_card$cardType4 = card.cardType) === null || _card$cardType4 === void 0 ? void 0 : _card$cardType4.id) === '8fad518d-cb7f-46f6-bbc6-6bc44c6e0faf';
      var skipEnrichment = !this.user.showEnrichedSentences && ((_card$cardType5 = card.cardType) === null || _card$cardType5 === void 0 ? void 0 : _card$cardType5.id) !== 'bfde0cda-d6fe-4524-965f-173eb841aa9e' || (0, _utils.isBlank)(card.sentence) || !forceEnrichment && card.isEnriched && !isTriviaCard;
      if (skipEnrichment) {
        return;
      }
      var triviaAnswer = isTriviaCard && (0, _utils.isPresent)(card.sentence.answers) ? card.sentence.answers[0] : null;
      if (!forceEnrichment && this.enrichedTranslations[card.sentence.id]) {
        card.setSentence(this.enrichedTranslations[card.sentence.id]);
      } else {
        this.sentenceStore.getShow({
          ids: {
            sentenceId: card.sentence.id
          }
        }, this.afterGetEnrichedSentence.bind(this, card));
      }
      if (isTriviaCard && triviaAnswer) {
        if (!forceEnrichment && this.enrichedTranslations[triviaAnswer.id]) {
          card.sentence.answers[0] = this.enrichedTranslations[triviaAnswer.id];
        } else {
          this.sentenceStore.getShow({
            ids: {
              sentenceId: triviaAnswer.id
            }
          }, this.afterGetEnrichedTriviaAnswer.bind(this, card));
        }
      }
    }
  }, {
    key: "afterGetEnrichedWord",
    value: function afterGetEnrichedWord(card, resp) {
      var word = (0, _serializr.deserialize)(_models.Word, resp);
      card.setWord(word);
      this.enrichedTranslations[resp.id] = word;
    }
  }, {
    key: "afterGetEnrichedSentence",
    value: function afterGetEnrichedSentence(card, resp) {
      var sentence = (0, _serializr.deserialize)(_models.Sentence, resp);
      card.setSentence(sentence);
      this.enrichedTranslations[resp.id] = sentence;
    }
  }, {
    key: "afterGetEnrichedTriviaAnswer",
    value: function afterGetEnrichedTriviaAnswer(card, resp) {
      var answer = (0, _serializr.deserialize)(_models.SentenceBasic, resp);
      card.sentence.answers[0] = answer;
      this.enrichedTranslations[resp.id] = answer;
    }
  }, {
    key: "getCaseGrammarHint",
    value: function getCaseGrammarHint(card, cardState) {
      var _card$concept, _card$cardType6, _card$sentence4;
      if (!(cardState !== null && cardState !== void 0 && cardState.revealed) || !(card !== null && card !== void 0 && (_card$concept = card.concept) !== null && _card$concept !== void 0 && _card$concept.shortDescription)) {
        return null;
      }
      if (((_card$cardType6 = card.cardType) === null || _card$cardType6 === void 0 ? void 0 : _card$cardType6.slug) !== 'case-multiple-choice') {
        return null;
      }
      var description = card.concept.shortDescription;
      if (description.includes('%target_text%')) {
        var _card$sentence3;
        var wordAssociation = (_card$sentence3 = card.sentence) === null || _card$sentence3 === void 0 || (_card$sentence3 = _card$sentence3.wordAssociations) === null || _card$sentence3 === void 0 ? void 0 : _card$sentence3.find(function (wa) {
          var _card$nounPhraseWordA, _wa$word;
          var isInNounPhrase = (_card$nounPhraseWordA = card.nounPhraseWordAssociationIds) === null || _card$nounPhraseWordA === void 0 ? void 0 : _card$nounPhraseWordA.includes(wa.id);
          var hasMatchingConcept = ((_wa$word = wa.word) === null || _wa$word === void 0 || (_wa$word = _wa$word.grammarCase) === null || _wa$word === void 0 ? void 0 : _wa$word.id) === card.concept.id;
          return isInNounPhrase && hasMatchingConcept;
        });
        if (wordAssociation !== null && wordAssociation !== void 0 && wordAssociation.targetText) {
          description = (0, _utils.capitalizeFirstLetter)(description.replace(/%target_text%/g, wordAssociation.targetText));
        } else {
          return null;
        }
      }
      var selectedWord = (_card$sentence4 = card.sentence) === null || _card$sentence4 === void 0 || (_card$sentence4 = _card$sentence4.wordAssociations) === null || _card$sentence4 === void 0 || (_card$sentence4 = _card$sentence4.find(function (wa) {
        var _card$wordAssociation;
        return (_card$wordAssociation = card.wordAssociationIds) === null || _card$wordAssociation === void 0 ? void 0 : _card$wordAssociation.includes(wa.id);
      })) === null || _card$sentence4 === void 0 ? void 0 : _card$sentence4.word;
      var correctCase = null;
      if (selectedWord) {
        if (selectedWord.isNominative) correctCase = 'nominative';else if (selectedWord.isGenitive) correctCase = 'genitive';else if (selectedWord.isDative) correctCase = 'dative';else if (selectedWord.isAccusative) correctCase = 'accusative';
      }
      return {
        description: description,
        concept: card.concept,
        color: _constants.Theme.caseColors[correctCase]
      };
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "cardSeenCount", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "wordClickCount", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "seenConceptDescription", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "selectedConceptDescriptionOpen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "cardNotice", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showCloseModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "animationQueue", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "deckNavigationCompleted", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "deckScreenFocused", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "lastFeedEntryId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "dataSaverModalSeen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "enrichedTranslations", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "overlayExpanded", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "sound", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "textRevealed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "arrowBoxIsHidden", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "cardIsAnimating", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "nativeCardTransition", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "firstCardHasAdvanced", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "suppressCardSwipeSpring", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "cardAnimationRecoveryRevision", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "cardAnimationNativeMountId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "userInputStores", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "shortcutsAssigned", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "animationCards", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "deviceDeniedAccess", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "showSlowDeckLoadingWarning", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "localDeck", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "localUserDeck", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "hideCardIcons", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "warning", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "showCorrectAnswer", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "reviewCards", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "reviewSessionReviewedBaseline", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "treeNodeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "treeNodeId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentUserCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentUserCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentCardState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentCardState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteIsSeedlang", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteIsSeedlang"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteIsMemrev", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteIsMemrev"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "site", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "site"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "routeToOnClose", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "routeToOnClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userInputStore", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userInputStore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearAudioStreams", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearAudioStreams"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disposeAllUserInputStores", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "disposeAllUserInputStores"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disposeDeckResources", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "disposeDeckResources"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetAllUserInputStores", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetAllUserInputStores"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "commentDebugInfo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "commentDebugInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDebugInfo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDebugInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "debugInfo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "debugInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordSentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordSentences"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasUserDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasUserDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCurrentCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCurrentCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCorrectCardStatus", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCorrectCardStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "levelIncremented", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "levelIncremented"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCardIsAnimating", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setCardIsAnimating"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSkipCardAnimation", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSkipCardAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "assignShortcut", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "assignShortcut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeShortcut", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeShortcut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isShortcutAssigned", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "isShortcutAssigned"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skipAnimationGotoLastCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "skipAnimationGotoLastCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "finishSkipAnimationGotoLastCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "finishSkipAnimationGotoLastCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skipAnimationNextCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "skipAnimationNextCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabSectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabSectionHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numVocabSections", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numVocabSections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabTextHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabTextHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onToggleReview", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onToggleReview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createEventOnServer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "createEventOnServer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterCreateReview", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterCreateReview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onEvaluateTextInput", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onEvaluateTextInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onWordInputChange", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onWordInputChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onWordInputChangeAndEvaluate", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onWordInputChangeAndEvaluate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkpointCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkpointCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordOptionsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordOptionsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckSummaryCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckSummaryCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "genderCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "genderCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "genderResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "genderResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "conjugationResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conjugationResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pluralCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pluralCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pluralResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pluralResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "synonymResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "synonymResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "caseResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "caseResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numberResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numberResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaIntroCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaIntroCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "describeCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "describeCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "answerCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "answerCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "comprehendCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "comprehendCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translateCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "translateCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabWordComprehendCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabWordComprehendCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabSentenceTranslateCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabSentenceTranslateCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabSentenceComprehendCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabSentenceComprehendCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabSentenceTranslateAudioCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabSentenceTranslateAudioCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDeckGenderCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDeckGenderCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDeckPluralCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDeckPluralCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDeckNumberCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDeckNumberCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDeckTriviaCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDeckTriviaCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deviceType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deviceType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelDeckLoad", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelDeckLoad"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkDeckLoadTime", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "checkDeckLoadTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterLoadDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterLoadDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterCreateUserDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterCreateUserDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "storyDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "storyDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showVocabExampleSentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showVocabExampleSentences"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "correctCardsStatusCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "correctCardsStatusCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentSentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentCardRevealed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentCardRevealed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDeckGrammar", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDeckGrammar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "adjustedDefaultXp", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "adjustedDefaultXp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onHideArrowBox", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onHideArrowBox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "designateUiElementAsSeen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "designateUiElementAsSeen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDeleteReview", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onDeleteReview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSnoozeReview", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSnoozeReview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "supplementMaximized", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "supplementMaximized"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDeckSupplement", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDeckSupplement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSupplementMedia", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSupplementMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "interjectionCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "interjectionCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userResponseCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userResponseCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabWordTranslateCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabWordTranslateCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabCardUsesAudio", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabCardUsesAudio"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showUserInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showUserInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNoUserInputBar", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showNoUserInputBar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSecondToLastCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSecondToLastCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFirstCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFirstCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDeckHeader", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDeckHeader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showLoadingIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showLoadingIcon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDeckGrammarIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDeckGrammarIcon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showVideoPlayer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showVideoPlayer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "videoPossible", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "videoPossible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "playUserInputRecording", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "playUserInputRecording"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "playUserInputAfterRevealVideo", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "playUserInputAfterRevealVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reveal", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reveal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onRevealVideoReady", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onRevealVideoReady"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onRevealVideoPlaying", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onRevealVideoPlaying"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onRevealVideoEnded", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onRevealVideoEnded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revealText", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "revealText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentCardSlug", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentCardSlug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableRecordButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableRecordButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pauseMedia", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "pauseMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideDeckArrowBox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideDeckArrowBox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showOnboardingTip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showOnboardingTip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mediaBlocked", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mediaBlocked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canRecordVideo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "canRecordVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deviceCanRecordMedia", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deviceCanRecordMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canRecordMedia", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "canRecordMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAncillaryCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showAncillaryCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLastCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLastCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onRetireReview", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onRetireReview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSpacedRepetitionFields", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSpacedRepetitionFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSubmitToFeed", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmitToFeed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createXpAnimation", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "createXpAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onWordClick", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onWordClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSoftReset", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSoftReset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createUserInputStores", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "createUserInputStores"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMobileOnCloseDeckCallback", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setMobileOnCloseDeckCallback"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setNativeLogger", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setNativeLogger"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setNativeKeyboardDismiss", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setNativeKeyboardDismiss"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setNativeCreateEventHandler", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setNativeCreateEventHandler"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reloadReviewDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reloadReviewDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCloseDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onCloseDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onResetUserInputStore", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onResetUserInputStore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onReset", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onReset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDeckScreenFocused", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setDeckScreenFocused"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openDeckVocabCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "openDeckVocabCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoVocabCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoVocabCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoWordVocabCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoWordVocabCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoTriviaResults", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoTriviaResults"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoShortcuts", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoShortcuts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoCardComments", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoCardComments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoGrammarTip", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoGrammarTip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoCardNote", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoCardNote"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoReviewDetails", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoReviewDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoConjugationTable", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoConjugationTable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoDeckSettings", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoDeckSettings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoReportBug", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoReportBug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoDeckGrammar", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoDeckGrammar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeDeckGrammar", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeDeckGrammar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoConceptDescription", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoConceptDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoTenseDescription", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoTenseDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoCaseDescription", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoCaseDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoMediaBlocked", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoMediaBlocked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skipToEnd", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "skipToEnd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "jumpToCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "jumpToCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoCardList", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoCardList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showExerciseAnswer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "showExerciseAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCorrectAnswer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onCorrectAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onIncorrectAnswer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onIncorrectAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "blurInputFocus", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "blurInputFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incrementXp", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "incrementXp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "advanceCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "advanceCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getXpSlug", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "getXpSlug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "blockLastLearningCardAdvancement", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "blockLastLearningCardAdvancement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextCurrentCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nextCurrentCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextCurrentCardId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nextCurrentCardId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoPreviousCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoPreviousCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCurrentCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setCurrentCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeFromAnimationQueue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeFromAnimationQueue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDeckNavigationCompleted", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setDeckNavigationCompleted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNewDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onNewDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeFeedInfo", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeFeedInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initializeCardAnimation", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeCardAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addNextCardToAnimationQueue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "addNextCardToAnimationQueue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startNativeCardTransition", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "startNativeCardTransition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "finishNativeCardTransition", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "finishNativeCardTransition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ensureCurrentAnimationCardIsVisible", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "ensureCurrentAnimationCardIsVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stabilizeCardAnimationPositions", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "stabilizeCardAnimationPositions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pauseCardAnimationForBackground", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "pauseCardAnimationForBackground"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addCardToAnimationQueue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "addCardToAnimationQueue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "decrementCardAnimationPositions", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "decrementCardAnimationPositions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCardAnimation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCardAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "advanceCards", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "advanceCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startCardAnimation", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "startCardAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeCardAnimation", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeCardAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resumeCardSwipeSpring", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resumeCardSwipeSpring"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recoverCardAnimationAfterForeground", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "recoverCardAnimationAfterForeground"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterCardAdvancement", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterCardAdvancement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enrichWord", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "enrichWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enrichSentence", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "enrichSentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetEnrichedWord", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetEnrichedWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetEnrichedSentence", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetEnrichedSentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetEnrichedTriviaAnswer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetEnrichedTriviaAnswer"), _class.prototype), _class);
var _default = exports["default"] = new DeckUI();